/** Phone catalog: assets/casento-phone-catalog.js (objednané kryty.pdf) — v1.4.0 */

var CASENTO_ASSET_VERSION = (function () {
  var meta = document.querySelector('meta[name="casento-theme-version"]');
  return meta ? meta.getAttribute('content') || '' : '';
})();

var CASENTO_PHOTO_KEY = 'casento_custom_photo';
var CASENTO_MAX_UPLOAD_MB = 30;
/** Výřezy fotoaparátů — pouze tvar modulu (bez jednotlivých čoček) */
var CASENTO_CAMERA_LAYOUTS = {
  'apple-pro': 'island--apple-pro',
  'apple-dual': 'island--apple-dual',
  'apple-se': 'island--apple-se',
  'samsung-ultra': 'island--samsung-ultra',
  'samsung-s': 'island--samsung-s',
  'samsung-fold': 'island--samsung-fold',
  'samsung-a': 'island--samsung-a',
  'pixel-bar': 'island--pixel-bar',
  pixel: 'island--pixel',
  'xiaomi-ultra': 'island--xiaomi-ultra',
  xiaomi: 'island--xiaomi',
  oneplus: 'island--oneplus',
  'huawei-pura': 'island--huawei-pura',
  huawei: 'island--huawei',
  generic: 'island--generic'
};

function resolveCaseShape(brandId, phoneName) {
  const p = (phoneName || '').toLowerCase();
  const b = (brandId || '').trim();
  if (!b) return 'generic';

  if (b === 'apple') {
    if (p.includes('se')) return 'apple-se';
    if (p.includes('pro')) return 'apple-pro';
    if (p) return 'apple-dual';
    return 'apple-pro';
  }

  if (b === 'samsung') {
    if (p.includes('fold') || p.includes('flip')) return 'samsung-fold';
    if (p.includes('ultra') || p.includes('note')) return 'samsung-ultra';
    if (p.match(/galaxy a|a\d{2}/)) return 'samsung-a';
    if (p) return 'samsung-s';
    return 'samsung-ultra';
  }

  if (b === 'google') {
    if (p.includes('pro') || p.includes('fold')) return 'pixel-bar';
    if (p) return 'pixel';
    return 'pixel-bar';
  }

  if (b === 'xiaomi') {
    if (p.includes('ultra')) return 'xiaomi-ultra';
    if (p) return 'xiaomi';
    return 'xiaomi';
  }

  if (b === 'oneplus') {
    return 'oneplus';
  }

  if (b === 'huawei') {
    if (p.includes('pura')) return 'huawei-pura';
    if (p) return 'huawei';
    return 'huawei-pura';
  }

  if (b === 'honor' || b === 'vivo' || b === 'oppo') {
    if (p.includes('ultra') || p.includes('magic') || p.includes('pro')) return 'xiaomi-ultra';
    return 'generic';
  }

  return 'generic';
}

function renderCameraIsland(mockup, shape) {
  const island = mockup.querySelector('[data-case-island]');
  if (!island) return;
  const islandClass = CASENTO_CAMERA_LAYOUTS[shape] || CASENTO_CAMERA_LAYOUTS.generic;
  island.className = 'case-mockup__island ' + islandClass;
  island.innerHTML = '';
}

function refreshStaleHeroLogo(root) {
  /* Hero uses casento-hero-logo SVG asset; legacy eyebrow fallback removed. */
}

(function () {
  const root = document.querySelector('.casento-premium');
  if (!root) return;

  refreshStaleHeroLogo(root);

  root.querySelectorAll('.upload-tabs').forEach(function (tabsEl) {
    const tabs = tabsEl.querySelectorAll('.u-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('active');
        });
        tab.classList.add('active');
      });
    });
  });

  initUploadWidget(root);
  initPhonePicker(root);
  initPickerCta(root);
  casentoResolvePickerVariant(root).catch(function () {
    /* produkt se načte znovu při přidání do košíku */
  });
  setUploadEmptyState(root);
  restorePhotoFromStorage(root);
  updateSizeHints(root, '');
  if (root.dataset.onePage === 'true') {
    updateOnePageFlow(root);
    initInlinePhotoServices(root);
    casentoInitSecondCaseMode(root);
  }

  root.querySelectorAll('.upload-tabs .u-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      const href = tab.getAttribute('data-tab-url');
      if (href) window.location.href = href;
    });
  });
})();

function casentoHasPhoto(root) {
  return root.dataset.hasPhoto === 'true' || !!casentoGetStoredPhoto();
}

function casentoIsValidPhotoDataUrl(value) {
  return typeof value === 'string' && /^data:image\//.test(value);
}

function casentoGetStoredPhoto() {
  try {
    const value = sessionStorage.getItem(CASENTO_PHOTO_KEY);
    if (!casentoIsValidPhotoDataUrl(value)) {
      if (value) {
        sessionStorage.removeItem(CASENTO_PHOTO_KEY);
      }
      return '';
    }
    return value;
  } catch (e) {
    return '';
  }
}

function casentoStorePhoto(dataUrl) {
  try {
    sessionStorage.setItem(CASENTO_PHOTO_KEY, dataUrl);
  } catch (e) {
    console.warn('Casento: fotku se nepodařilo uložit do prohlížeče.', e);
  }
}

function casentoClearPhoto() {
  try {
    sessionStorage.removeItem(CASENTO_PHOTO_KEY);
  } catch (e) {
    /* ignore */
  }
}

function compressImageFile(file) {
  return new Promise(function (resolve, reject) {
    const reader = new FileReader();
    reader.onload = function () {
      const img = new Image();
      img.onload = function () {
        const maxW = 1400;
        const scale = img.width > maxW ? maxW / img.width : 1;
        const w = Math.round(img.width * scale);
        const h = Math.round(img.height * scale);
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          resolve(reader.result);
          return;
        }
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL('image/jpeg', 0.86));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function setUploadDoneState(root, dataUrl) {
  const empty = root.querySelector('[data-upload-empty]');
  const done = root.querySelector('[data-upload-done]');
  const thumb = root.querySelector('[data-upload-thumb]');
  if (empty) empty.hidden = true;
  if (done) done.hidden = false;
  if (thumb) thumb.src = dataUrl;
  root.dataset.hasPhoto = 'true';
  casentoSyncServiceOriginalPreview(root);
}

function setUploadEmptyState(root) {
  const empty = root.querySelector('[data-upload-empty]');
  const done = root.querySelector('[data-upload-done]');
  const thumb = root.querySelector('[data-upload-thumb]');
  if (empty) empty.hidden = false;
  if (done) done.hidden = true;
  if (thumb) thumb.removeAttribute('src');
  root.dataset.hasPhoto = 'false';
  casentoSyncServiceOriginalPreview(root);
}

function scrollToCopStep(root, stepId) {
  const el = root.querySelector('#cop-step-' + stepId);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const head = el.querySelector('.cop-step__head');
    if (head) {
      window.setTimeout(function () {
        head.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 280);
    }
  }
}

function setCopStepLocked(root, stepName, locked) {
  const step = root.querySelector('[data-cop-step="' + stepName + '"]');
  if (!step) return;
  step.classList.toggle('is-locked', locked);
  step.setAttribute('aria-disabled', locked ? 'true' : 'false');
  step.querySelectorAll('button, input, select, textarea').forEach(function (el) {
    el.disabled = !!locked;
  });
}

function setUploadControlsEnabled(root, enabled) {
  const input = root.querySelector('[data-upload-input]');
  const triggers = root.querySelectorAll('[data-upload-trigger]');
  if (input) input.disabled = !enabled;
  triggers.forEach(function (btn) {
    btn.disabled = !enabled;
  });
}

function updateOnePageFlow(root) {
  if (root.dataset.onePage !== 'true') return;

  const hasPhoto = casentoHasPhoto(root);
  const hasPhone = isPhoneSelectionComplete(root);
  const hasService = casentoHasValidInlineServiceSelection(root);

  setCopStepLocked(root, 'photo', !hasPhone);
  setUploadControlsEnabled(root, hasPhone);
  setCopStepLocked(root, 'service', !(hasPhone && hasPhoto));
  setCopStepLocked(root, 'cart', !(hasPhone && hasPhoto && hasService));
  updateCasePreview(root);
  casentoSyncServiceOriginalPreview(root);

  root.querySelectorAll('[data-cop-step]').forEach(function (step) {
    const name = step.getAttribute('data-cop-step');
    step.classList.remove('is-complete');
    if (name === 'phone' && hasPhone) step.classList.add('is-complete');
    if (name === 'photo' && hasPhoto) step.classList.add('is-complete');
    if (name === 'service' && hasService) step.classList.add('is-complete');
    if (name === 'cart' && hasPhone && hasPhoto && hasService) step.classList.add('is-complete');
  });
}

function scrollToPhonePicker(root) {
  if (root.dataset.onePage === 'true') {
    scrollToCopStep(root, 'phone');
    return;
  }
  const target = root.querySelector('[data-picker-section]') || document.getElementById('casento-phone-picker');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function casentoGetCaseSpecs(phoneName) {
  if (window.CasentoCaseSpecs && window.CasentoCaseSpecs.get) {
    return window.CasentoCaseSpecs.get(phoneName || '');
  }
  return { mmW: 64, mmH: 145, pxW: 756, pxH: 1713 };
}

function casentoFormatSizeHint(phoneName) {
  if (window.CasentoCaseSpecs && window.CasentoCaseSpecs.formatHint) {
    return window.CasentoCaseSpecs.formatHint(phoneName || '');
  }
  return 'Doporučená velikost: min. 1500 × 2000 px (vyber telefon pro přesné rozměry)';
}

function updateSizeHints(root, phoneName) {
  const uploadHint = root.querySelector('[data-upload-size-hint]');
  const pickerHint = root.querySelector('[data-picker-size-hint]');
  const phone = (phoneName != null ? phoneName : root.dataset.selectedPhone || '').trim();
  const text = casentoFormatSizeHint(phone);

  if (uploadHint) {
    uploadHint.textContent = text;
    uploadHint.classList.remove('is-warning');
  }
  if (pickerHint) {
    if (phone && casentoGetStoredPhoto()) {
      pickerHint.hidden = false;
      pickerHint.textContent = text;
    } else {
      pickerHint.hidden = true;
    }
  }
}

function validatePhotoDimensions(root, dataUrl, phoneName) {
  const phone = (phoneName || root.dataset.selectedPhone || '').trim();
  const specs = casentoGetCaseSpecs(phone);
  const img = new Image();
  img.onload = function () {
    const uploadHint = root.querySelector('[data-upload-size-hint]');
    if (!uploadHint) return;
    const minW = Math.round(specs.pxW * 0.85);
    const minH = Math.round(specs.pxH * 0.85);
    if (img.width < minW || img.height < minH) {
      uploadHint.classList.add('is-warning');
      uploadHint.textContent =
        'Fotka je malá (' +
        img.width +
        '×' +
        img.height +
        ' px). ' +
        casentoFormatSizeHint(phone) +
        ' — tisk může být rozmazaný.';
    } else {
      updateSizeHints(root, phone);
    }
  };
  img.src = dataUrl;
}

function dataUrlToBlob(dataUrl) {
  const parts = dataUrl.split(',');
  const mimeMatch = parts[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
  const bin = atob(parts[1]);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type: mime });
}

function casentoUploadPhotoToCloud(root) {
  const cloud = root.getAttribute('data-cloudinary-cloud');
  const preset = root.getAttribute('data-cloudinary-preset');
  const dataUrl = casentoGetStoredPhoto();
  if (!cloud || !preset || !dataUrl) {
    return Promise.resolve(null);
  }

  const form = new FormData();
  form.append('file', dataUrlToBlob(dataUrl));
  form.append('upload_preset', preset);
  form.append('folder', 'casento-orders');

  return fetch('https://api.cloudinary.com/v1_1/' + cloud + '/image/upload', {
    method: 'POST',
    body: form
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      if (data.error) throw new Error(data.error.message || 'Upload failed');
      return data.secure_url || data.url || null;
    });
}

function handlePhotoSelected(root, file) {
  if (!file || !file.type.match(/^image\//)) {
    alert('Vyber prosím obrázek (JPG, PNG nebo WEBP).');
    return;
  }
  if (file.size > CASENTO_MAX_UPLOAD_MB * 1024 * 1024) {
    alert('Soubor je příliš velký. Maximum je ' + CASENTO_MAX_UPLOAD_MB + ' MB.');
    return;
  }

  compressImageFile(file)
    .then(function (dataUrl) {
      casentoStorePhoto(dataUrl);
      setUploadDoneState(root, dataUrl);
      updateCasePreview(root);
      updatePickerHeading(root);
      updatePickerCta(root);
      updateSizeHints(root, root.dataset.selectedPhone || '');
      validatePhotoDimensions(root, dataUrl, root.dataset.selectedPhone || '');
      if (root.dataset.onePage === 'true') {
        casentoAutoConfirmOriginalIfSelected(root);
        updateOnePageFlow(root);
        scrollToCopStep(root, 'service');
      } else {
        scrollToPhonePicker(root);
      }
    })
    .catch(function () {
      alert('Fotku se nepodařilo načíst. Zkus jiný soubor.');
    });
}

function initUploadWidget(root) {
  const drop = root.querySelector('[data-upload-drop]');
  const input = root.querySelector('[data-upload-input]');
  if (!drop || !input) return;

  root.querySelectorAll('[data-upload-trigger], [data-upload-change]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      input.click();
    });
  });

  input.addEventListener('change', function () {
    if (input.files && input.files[0]) {
      handlePhotoSelected(root, input.files[0]);
      input.value = '';
    }
  });

  drop.addEventListener('click', function (e) {
    if (e.target.closest('[data-upload-change]')) return;
    if (e.target.closest('button')) return;
    if (root.dataset.hasPhoto === 'true') return;
    input.click();
  });

  drop.addEventListener('dragover', function (e) {
    e.preventDefault();
    drop.classList.add('is-dragover');
  });

  drop.addEventListener('dragleave', function () {
    drop.classList.remove('is-dragover');
  });

  drop.addEventListener('drop', function (e) {
    e.preventDefault();
    drop.classList.remove('is-dragover');
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handlePhotoSelected(root, e.dataTransfer.files[0]);
    }
  });
}

function restorePhotoFromStorage(root) {
  const dataUrl = casentoGetStoredPhoto();
  if (!dataUrl) {
    setUploadEmptyState(root);
    updateOnePageFlow(root);
    return;
  }

  const img = new Image();
  img.onload = function () {
    setUploadDoneState(root, dataUrl);
    updateCasePreview(root);
    updatePickerHeading(root);
    updatePickerCta(root);
    updateSizeHints(root, root.dataset.selectedPhone || '');
    casentoAutoConfirmOriginalIfSelected(root);
    updateOnePageFlow(root);
  };
  img.onerror = function () {
    casentoClearPhoto();
    setUploadEmptyState(root);
    updateCasePreview(root);
    updatePickerHeading(root);
    updatePickerCta(root);
    updateSizeHints(root, root.dataset.selectedPhone || '');
    updateOnePageFlow(root);
  };
  img.src = dataUrl;
}

function getPreviewPhoneLabel(root, phone, placeholder) {
  const caseType = (root.dataset.selectedCaseType || '').trim();
  if (!phone) return placeholder;
  if (caseType) return phone + ' · ' + caseType;
  return phone;
}

function updateCaseShape(root, brandId, phoneName) {
  const mockups = root.querySelectorAll('[data-case-mockup]');
  if (!mockups.length) return;
  const brand =
    brandId ||
    (root.querySelector('[data-chip-group="brand"] .chip.on[data-brand-id]') &&
      root.querySelector('[data-chip-group="brand"] .chip.on[data-brand-id]').getAttribute('data-brand-id')) ||
    '';
  const phone = phoneName != null ? phoneName : (root.dataset.selectedPhone || '').trim();
  const shape = resolveCaseShape(brand, phone);
  mockups.forEach(function (mockup) {
    mockup.dataset.caseShape = shape;
    if (!mockup.hasAttribute('data-case-no-camera')) {
      renderCameraIsland(mockup, shape);
    }
  });
}

function updateCasePreview(root) {
  const isOnePage = root.dataset.onePage === 'true';
  const pickerWrap = root.querySelector('[data-picker-preview-wrap]');
  const cartWrap = root.querySelector('[data-cart-preview-wrap]');
  const grid = root.querySelector('.picker-grid');
  const photos = root.querySelectorAll('[data-case-photo]');
  const pickerLabel = root.querySelector('[data-preview-phone]');
  const cartLabel = root.querySelector('[data-cart-preview-phone]');
  const photo = casentoGetStoredPhoto();
  const phone = (root.dataset.selectedPhone || '').trim();
  const picker = root.querySelector('[data-picker-section]');
  const placeholder =
    (picker && picker.getAttribute('data-preview-placeholder')) || 'Vyber řadu a verzi';
  const brandChip = root.querySelector('[data-chip-group="brand"] .chip.on[data-brand-id]');
  const brandId = brandChip ? brandChip.getAttribute('data-brand-id') : '';
  const labelText = getPreviewPhoneLabel(root, phone, placeholder);
  const showPreview = !!photo && (!isOnePage || isPhoneSelectionComplete(root));

  if (!showPreview) {
    if (pickerWrap) pickerWrap.hidden = true;
    if (cartWrap) cartWrap.hidden = true;
    if (grid) grid.classList.remove('picker-grid--with-preview');
    return;
  }

  photos.forEach(function (img) {
    img.src = photo;
  });

  if (isOnePage) {
    if (pickerWrap) pickerWrap.hidden = true;
    if (cartWrap) cartWrap.hidden = false;
    if (grid) grid.classList.remove('picker-grid--with-preview');
    if (cartLabel) cartLabel.textContent = labelText;
  } else {
    if (pickerWrap) pickerWrap.hidden = false;
    if (cartWrap) cartWrap.hidden = true;
    if (grid) grid.classList.add('picker-grid--with-preview');
    if (pickerLabel) pickerLabel.textContent = labelText;
  }

  updateCaseShape(root, brandId, phone);
  updateSizeHints(root, phone);
  if (photo && phone) {
    validatePhotoDimensions(root, photo, phone);
  }
}

function updatePickerHeading(root) {
  const heading = root.querySelector('[data-picker-heading]');
  const section = root.querySelector('[data-picker-section]');
  if (!heading || !section) return;
  if (casentoHasPhoto(root)) {
    heading.textContent = section.getAttribute('data-heading-with-photo') || heading.textContent;
  } else {
    heading.textContent = section.getAttribute('data-heading-default') || heading.textContent;
  }
}

function initPickerCta(root) {
  const cta = root.querySelector('[data-picker-cta]');
  if (!cta) return;
  cta.addEventListener('click', function () {
    if (cta.disabled) return;
    const mode = cta.dataset.mode;
    if (mode === 'cart') {
      casentoAddToCart(root, cta);
    } else if (mode === 'upload' && root.dataset.onePage !== 'true') {
      scrollToHeroUpload(root);
    }
  });
}

function casentoResolvePickerVariant(root, serviceId) {
  const handle = (root.getAttribute('data-product-handle') || '').trim();
  if (!handle) return Promise.resolve(null);

  const resolvedServiceId =
    serviceId ||
    (casentoGetSelectedInlineService(root) && casentoGetSelectedInlineService(root).serviceId) ||
    'original';
  const total = casentoCalculateTotal(root, resolvedServiceId);
  const targetCents = Math.round(total * 100);
  const cacheKey = handle + ':' + targetCents;

  if (!root._casentoVariantCache) root._casentoVariantCache = {};
  if (root._casentoVariantCache[cacheKey]) {
    return Promise.resolve(root._casentoVariantCache[cacheKey]);
  }

  return fetch('/products/' + encodeURIComponent(handle) + '.js', {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin'
  })
    .then(function (res) {
      if (!res.ok) throw new Error('product_not_found');
      return res.json();
    })
    .then(function (product) {
      const variants = product.variants || [];
      let variant =
        variants.find(function (v) {
          return parseInt(v.price, 10) === targetCents;
        }) ||
        variants.find(function (v) {
          return Math.abs(parseFloat(v.price) - total) < 0.01;
        });
      if (!variant) {
        variant =
          variants.find(function (v) {
            return v.available;
          }) || variants[0];
      }
      if (!variant) throw new Error('no_variant');
      const id = String(variant.id);
      root._casentoVariantCache[cacheKey] = id;
      return id;
    });
}

function scrollToHeroUpload(root) {
  const drop = root.querySelector('[data-upload-drop]');
  const input = root.querySelector('[data-upload-input]');
  if (drop) {
    drop.scrollIntoView({ behavior: 'smooth', block: 'center' });
    drop.classList.add('is-dragover');
    setTimeout(function () {
      drop.classList.remove('is-dragover');
    }, 1200);
  }
  if (input) {
    setTimeout(function () {
      input.click();
    }, 400);
  }
}

function casentoGoToCart() {
  window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
}

function casentoGetPricing(root) {
  return {
    base: parseInt(root.getAttribute('data-price-base') || '545', 10),
    magsafe: parseInt(root.getAttribute('data-price-magsafe-addon') || '95', 10),
    premiumBg: parseInt(root.getAttribute('data-price-premium-bg') || '640', 10),
    proEdit: parseInt(root.getAttribute('data-price-pro-edit') || '640', 10)
  };
}

function casentoIsMagSafe(root) {
  return (root.dataset.selectedCaseType || '').trim() === 'MagSafe';
}

function casentoFormatCz(amount) {
  return Number(amount).toLocaleString('cs-CZ') + ' Kč';
}

function casentoServiceBasePrice(pricing, serviceId) {
  if (serviceId === 'premium_bg') return pricing.premiumBg;
  if (serviceId === 'pro_edit') return pricing.proEdit;
  return pricing.base;
}

function casentoCalculateTotal(root, serviceId) {
  const pricing = casentoGetPricing(root);
  let total = casentoServiceBasePrice(pricing, serviceId || 'original');
  if (casentoIsMagSafe(root)) total += pricing.magsafe;
  return total;
}

function casentoIsSecondCaseMode(root) {
  return !!(root && root.dataset.casentoMode === 'second-case');
}

function casentoGetBundleHandle(root) {
  return (root.getAttribute('data-bundle-handle') || 'druhy-kryt-akce').trim();
}

function casentoGetBundlePrice(root) {
  return parseInt(root.getAttribute('data-bundle-price') || '595', 10);
}

function casentoResolveBundleVariant(root) {
  const handle = casentoGetBundleHandle(root);
  if (!handle) return Promise.resolve(null);
  if (root._casentoBundleVariantPromise) return root._casentoBundleVariantPromise;

  root._casentoBundleVariantPromise = fetch('/products/' + encodeURIComponent(handle) + '.js', {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin'
  })
    .then(function (res) {
      if (!res.ok) throw new Error('missing_bundle_product');
      return res.json();
    })
    .then(function (product) {
      const variants = product.variants || [];
      const bundlePrice = casentoGetBundlePrice(root);
      const targetCents = Math.round(bundlePrice * 100);
      const variant =
        variants.find(function (v) {
          return parseInt(v.price, 10) === targetCents;
        }) ||
        variants.find(function (v) {
          return v.available;
        }) ||
        variants[0];
      if (!variant) throw new Error('no_bundle_variant');
      return String(variant.id);
    })
    .catch(function (err) {
      root._casentoBundleVariantPromise = null;
      throw err;
    });

  return root._casentoBundleVariantPromise;
}

function casentoRemoveBundleCartLines(root) {
  const handle = casentoGetBundleHandle(root);
  return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      const keys = [];
      cart.items.forEach(function (item) {
        const props = item.properties || {};
        if (item.handle === handle || props['_Položka'] === 'druhy-kryt') {
          keys.push(item.key);
        }
      });
      return keys.reduce(function (chain, key) {
        return chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        });
      }, Promise.resolve());
    });
}

function casentoResetEditorForSecondCase(root) {
  root.dataset.selectedPhone = '';
  root.dataset.selectedCaseType = '';
  root.dataset.selectedPhotoService = '';
  root.dataset.selectedPhotoServiceLabel = '';
  root.dataset.confirmedPhotoService = '';
  root.dataset.selectedPhotoBackground = '';
  const input = root.querySelector('[data-model-search-input]');
  if (input) input.value = '';
  collapseVariantStep(root);
  collapseCaseTypeStep(root);
  root.querySelectorAll('[data-photo-service]').forEach(function (el) {
    el.classList.remove('is-selected');
    el.setAttribute('aria-checked', 'false');
  });
  root.querySelectorAll('[data-photo-background]').forEach(function (el) {
    el.classList.remove('is-selected');
  });
  updateCasePreview(root);
  updateOnePageFlow(root);
}

function casentoInitSecondCaseMode(root) {
  const params = new URLSearchParams(window.location.search);
  if (params.get('casento') !== 'druhy-kryt') return;

  root.dataset.casentoMode = 'second-case';
  casentoResetEditorForSecondCase(root);

  const banner = root.querySelector('[data-second-case-banner]');
  if (banner) banner.hidden = false;
  root.classList.add('is-second-case-mode');

  const priceWrap = root.querySelector('[data-cart-price-wrap]');
  if (priceWrap) {
    const prefix = priceWrap.childNodes[0];
    if (prefix && prefix.nodeType === 3) {
      priceWrap.childNodes[0].textContent = '';
    }
  }

  casentoUpdateCartPriceDisplay(root, 'original');
  updatePickerCta(root);
  scrollToCopStep(root, 'phone');
}

function casentoBuildCaseLineProperties(root, phone, selectedService, photoUrl, hasCloud) {
  const props = {
    'Model telefonu': phone,
    'Vlastní fotka': 'Ano'
  };
  const specs = casentoGetCaseSpecs(phone);
  if (specs) {
    props['_Rozměr tisku'] =
      specs.mmW + ' × ' + specs.mmH + ' mm (' + specs.pxW + ' × ' + specs.pxH + ' px)';
  }
  const caseType = (root.dataset.selectedCaseType || '').trim();
  if (caseType) {
    props['Typ krytu'] = caseType;
  }
  Object.assign(
    props,
    casentoPhotoServiceProps(
      root,
      selectedService.serviceId,
      selectedService.serviceLabel,
      selectedService.background || null
    )
  );
  if (photoUrl) {
    props['_Fotka pro tisk'] = photoUrl;
  } else if (!hasCloud) {
    props['_Fotka pro tisk'] = 'Chybí — nastav Cloudinary v motivu';
  }
  return props;
}

function casentoFinishSecondCaseModeUrl() {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete('casento');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  } catch (e) {
    /* ignore */
  }
}

function casentoUpdateCartPriceDisplay(root, serviceId) {
  const el = root.querySelector('[data-cart-price-value]');
  if (!el) return;
  if (casentoIsSecondCaseMode(root)) {
    el.textContent = casentoFormatCz(casentoGetBundlePrice(root));
    return;
  }
  const total = casentoCalculateTotal(root, serviceId || 'original');
  el.textContent = casentoFormatCz(total);
}

function casentoPhotoServiceProps(root, serviceId, serviceLabel, backgroundLabel) {
  const props = {};
  const total = casentoIsSecondCaseMode(root)
    ? casentoGetBundlePrice(root)
    : casentoCalculateTotal(root, serviceId);
  props['Cena'] = casentoFormatCz(total);
  props['_Cena Kč'] = String(total);

  if (serviceId === 'premium_bg' && backgroundLabel) {
    props['Foto služba'] = serviceLabel + ' — ' + backgroundLabel;
    props['_Pozadí'] = backgroundLabel;
  } else {
    props['Foto služba'] = serviceLabel;
  }
  return props;
}

function casentoResolveProductVariant(handle) {
  if (!handle) return Promise.resolve(null);
  return fetch('/products/' + encodeURIComponent(handle) + '.js', {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin'
  })
    .then(function (res) {
      if (!res.ok) throw new Error('missing');
      return res.json();
    })
    .then(function (product) {
      const variants = product.variants || [];
      const variant = variants.find(function (v) {
        return v.available;
      }) || variants[0];
      return variant ? variant.id : null;
    })
    .catch(function () {
      return null;
    });
}

function casentoSurchargeHandles(root) {
  return [
    root.getAttribute('data-surcharge-magsafe-handle') || 'priplatek-magsafe',
    root.getAttribute('data-surcharge-pozadi-handle') || 'priplatek-pozadi',
    root.getAttribute('data-surcharge-grafik-handle') || 'priplatek-grafik'
  ];
}

function casentoRemoveCartSurcharges(root) {
  const handles = casentoSurchargeHandles(root);

  return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      const tasks = [];
      cart.items.forEach(function (item, index) {
        if (handles.indexOf(item.handle) >= 0) {
          tasks.push(
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ line: index + 1, quantity: 0 })
            })
          );
        }
      });
      return Promise.all(tasks);
    })
    .catch(function () {
      /* staré příplatkové řádky nemusí existovat */
    });
}

window.casentoRemoveCartSurcharges = casentoRemoveCartSurcharges;

function casentoReplaceCartLine(root, lineKey, serviceId, extraProps) {
  return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      let idx = -1;
      for (let i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === lineKey) {
          idx = i;
          break;
        }
      }
      if (idx < 0) throw new Error('line_not_found');
      const item = cart.items[idx];
      const props = {};
      const existing = item.properties || {};
      Object.keys(existing).forEach(function (key) {
        if (existing[key]) props[key] = existing[key];
      });
      Object.keys(extraProps).forEach(function (key) {
        props[key] = extraProps[key];
      });
      return casentoResolvePickerVariant(root, serviceId).then(function (variantId) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line: idx + 1, quantity: 0 })
        }).then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: item.quantity, properties: props }]
            })
          });
        });
      });
    });
}

function casentoStopBgCarousels(modal) {
  if (!modal) return;
  modal.querySelectorAll('[data-bg-carousel]').forEach(function (carousel) {
    if (carousel._autoTimer) {
      clearInterval(carousel._autoTimer);
      carousel._autoTimer = null;
    }
  });
}

function casentoStartBgCarousels(modal) {
  if (!modal) return;
  modal.querySelectorAll('[data-bg-carousel]').forEach(function (carousel) {
    if (typeof carousel._goToSlide !== 'function') return;
    const slides = carousel.querySelectorAll('[data-bg-slide]');
    if (slides.length < 2) return;
    if (carousel._autoTimer) clearInterval(carousel._autoTimer);
    carousel._autoTimer = setInterval(function () {
      carousel._goToSlide((carousel._slideIndex || 0) + 1);
    }, 2000);
  });
}

function bindBgCarousel(carousel) {
  if (carousel.dataset.bound) return;
  carousel.dataset.bound = '1';

  const card = carousel.closest('[data-photo-background]');
  const slides = carousel.querySelectorAll('[data-bg-slide]');
  const dotsWrap = card && card.querySelector('[data-bg-dots]');
  const dots = dotsWrap ? dotsWrap.querySelectorAll('[data-bg-dot]') : [];
  if (slides.length < 2) return;

  carousel._slideIndex = 0;

  function goTo(nextIndex) {
    carousel._slideIndex = (nextIndex + slides.length) % slides.length;
    slides.forEach(function (slide, i) {
      const active = i === carousel._slideIndex;
      slide.classList.toggle('is-active', active);
      slide.toggleAttribute('hidden', !active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === carousel._slideIndex);
    });
  }

  carousel._goToSlide = goTo;

  const prev = carousel.querySelector('[data-bg-prev]');
  const next = carousel.querySelector('[data-bg-next]');

  if (prev) {
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      goTo(carousel._slideIndex - 1);
    });
  }
  if (next) {
    next.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      goTo(carousel._slideIndex + 1);
    });
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      goTo(i);
    });
  });
}

function initBgCarousels(modal) {
  modal.querySelectorAll('[data-bg-carousel]').forEach(bindBgCarousel);
  const wrap = modal.querySelector('[data-photo-backgrounds-wrap]');
  if (wrap && !wrap.hidden) {
    casentoStartBgCarousels(modal);
  }
  casentoBindBgHoverPreview(modal);
}

var casentoBgHoverPreviewEl = null;
var casentoBgHoverCarouselTimer = null;
var casentoBgHoverSlideIndex = 0;
var casentoLightboxKeyBound = false;

function casentoEnsureBgHoverPreview() {
  if (casentoBgHoverPreviewEl) return casentoBgHoverPreviewEl;

  casentoBgHoverPreviewEl = document.createElement('div');
  casentoBgHoverPreviewEl.className = 'cop-bg-hover-preview cop-bg-hover-preview--lightbox';
  casentoBgHoverPreviewEl.setAttribute('data-bg-hover-preview', '');
  casentoBgHoverPreviewEl.setAttribute('role', 'dialog');
  casentoBgHoverPreviewEl.setAttribute('aria-modal', 'true');
  casentoBgHoverPreviewEl.hidden = true;
  casentoBgHoverPreviewEl.innerHTML =
    '<button type="button" class="cop-bg-hover-preview__close" data-bg-lightbox-close aria-label="Zavřít">' +
    '<i class="ti ti-x" aria-hidden="true"></i>' +
    '</button>' +
    '<div class="cop-bg-hover-preview__inner">' +
    '<p class="cop-bg-hover-preview__title" data-bg-hover-title></p>' +
    '<div class="cop-bg-hover-preview__viewport" data-bg-hover-viewport></div>' +
    '<button type="button" class="btn-casento-add btn-casento-add--block cop-bg-hover-preview__select" data-bg-lightbox-select hidden>Vybrat</button>' +
    '</div>';

  casentoBgHoverPreviewEl.querySelectorAll('[data-bg-lightbox-close]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      casentoHideBgHoverPreview();
    });
  });

  const selectBtn = casentoBgHoverPreviewEl.querySelector('[data-bg-lightbox-select]');
  if (selectBtn) {
    selectBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const caseChip = casentoBgHoverPreviewEl._sourceCaseChip;
      if (caseChip) {
        caseChip.click();
        casentoHideBgHoverPreview();
        return;
      }
      const selectTarget = casentoBgHoverPreviewEl._sourceSelectTarget;
      if (selectTarget) {
        selectTarget.click();
        casentoHideBgHoverPreview();
        return;
      }
      const card = casentoBgHoverPreviewEl._sourceBgCard;
      if (!card) return;
      const root = card.closest('.casento-one-page, .casento-premium');
      if (!root) return;
      casentoSelectBackgroundCard(root, card);
      casentoHideBgHoverPreview();
    });
  }

  if (!casentoLightboxKeyBound) {
    casentoLightboxKeyBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!casentoBgHoverPreviewEl || casentoBgHoverPreviewEl.hidden) return;
      casentoHideBgHoverPreview();
    });
  }

  document.body.appendChild(casentoBgHoverPreviewEl);
  return casentoBgHoverPreviewEl;
}

function casentoStopBgHoverCarousel() {
  if (casentoBgHoverCarouselTimer) {
    clearInterval(casentoBgHoverCarouselTimer);
    casentoBgHoverCarouselTimer = null;
  }
}

function casentoGoBgHoverSlide(slides, nextIndex, popup) {
  if (!slides.length) return;
  casentoBgHoverSlideIndex = (nextIndex + slides.length) % slides.length;
  slides.forEach(function (slide, i) {
    slide.classList.toggle('is-active', i === casentoBgHoverSlideIndex);
    slide.toggleAttribute('hidden', i !== casentoBgHoverSlideIndex);
  });

  const active = slides[casentoBgHoverSlideIndex];
  if (!popup || !active || active.tagName !== 'IMG') return;

  if (active.complete && active.naturalWidth) {
    casentoFitLightboxViewport(popup, active);
    return;
  }

  active.addEventListener(
    'load',
    function onLoad() {
      active.removeEventListener('load', onLoad);
      if (active.classList.contains('is-active')) {
        casentoFitLightboxViewport(popup, active);
      }
    },
    { once: true }
  );
}

function casentoGetBgCardLightboxConfig(card) {
  const cardSlides = Array.prototype.slice
    .call(card.querySelectorAll('[data-bg-slide]'))
    .filter(function (slide) {
      return slide.tagName === 'IMG' && (slide.getAttribute('data-full-src') || slide.getAttribute('src'));
    });
  if (!cardSlides.length) return null;

  return {
    title: card.getAttribute('data-bg-label') || 'Pozadí',
    objectFit: 'contain',
    images: cardSlides.map(function (slide) {
      return {
        src: slide.getAttribute('data-full-src') || slide.getAttribute('src') || '',
        alt: slide.getAttribute('alt') || ''
      };
    })
  };
}

function casentoResetLightboxViewport(popup) {
  if (!popup) return;
  const viewport = popup.querySelector('[data-bg-hover-viewport]');
  if (viewport) {
    viewport.style.width = '';
    viewport.style.height = '';
  }
}

function casentoFitLightboxViewport(popup, img) {
  const viewport = popup && popup.querySelector('[data-bg-hover-viewport]');
  if (!viewport || !img) return;

  const nw = img.naturalWidth;
  const nh = img.naturalHeight;
  if (!nw || !nh) return;

  const maxW = Math.min(960, window.innerWidth - 32);
  const maxH = Math.max(240, window.innerHeight - 160);
  const ratio = nw / nh;

  let w = maxW;
  let h = w / ratio;
  if (h > maxH) {
    h = maxH;
    w = h * ratio;
  }

  viewport.style.width = Math.round(w) + 'px';
  viewport.style.height = Math.round(h) + 'px';
  popup.classList.toggle('cop-bg-hover-preview--portrait', nh > nw);
  popup.classList.toggle('cop-bg-hover-preview--landscape', nw > nh);
}

function casentoShowImageLightbox(trigger, config, options) {
  config = config || {};
  options = options || {};
  const images = config.images || [];
  if (!images.length) return;

  casentoStopBgHoverCarousel();

  const popup = casentoEnsureBgHoverPreview();
  const title = popup.querySelector('[data-bg-hover-title]');
  const viewport = popup.querySelector('[data-bg-hover-viewport]');
  const selectBtn = popup.querySelector('[data-bg-lightbox-select]');
  if (!title || !viewport) return;

  title.textContent = config.title || 'Náhled';
  viewport.innerHTML = '';
  casentoResetLightboxViewport(popup);
  popup.classList.remove('cop-bg-hover-preview--portrait', 'cop-bg-hover-preview--landscape');
  popup.classList.toggle('cop-bg-hover-preview--landscape', !!config.landscape);
  popup.classList.toggle('cop-bg-hover-preview--square', !!config.square && !config.landscape);

  const popupSlides = images.map(function (image, i) {
    const img = document.createElement('img');
    img.className = 'cop-bg-hover-preview__slide' + (i === 0 ? ' is-active' : '');
    img.src = image.src || '';
    img.alt = image.alt || title.textContent;
    img.style.objectFit = config.objectFit || 'contain';
    img.style.objectPosition = 'center center';
    img.decoding = 'async';
    if (config.rotate) img.style.transform = 'rotate(' + config.rotate + 'deg)';
    if (i > 0) img.hidden = true;
    viewport.appendChild(img);
    return img;
  });

  popupSlides.forEach(function (img, i) {
    img.addEventListener('load', function () {
      if (img.classList.contains('is-active')) {
        casentoFitLightboxViewport(popup, img);
      }
    });
    if (i === 0 && img.complete && img.naturalWidth) {
      casentoFitLightboxViewport(popup, img);
    }
  });

  popup._sourceBgCard = options.sourceBgCard || null;
  popup._sourceCaseChip = options.sourceCaseChip || null;
  popup._sourceSelectTarget = options.sourceSelectTarget || null;
  const showSelect = !!(options.sourceBgCard || options.sourceCaseChip || options.sourceSelectTarget);
  popup.classList.toggle('is-bg-selectable', showSelect);
  if (selectBtn) {
    selectBtn.hidden = !showSelect;
    selectBtn.textContent = options.selectLabel || (options.sourceBgCard ? 'Vybrat pozadí' : 'Vybrat');
  }

  popup.classList.add('is-active');
  popup.hidden = false;
  casentoBgHoverSlideIndex = 0;
  document.body.classList.add('casento-lightbox-open');
  popup.setAttribute('aria-label', config.title || 'Náhled');

  if (popupSlides.length > 1) {
    casentoBgHoverCarouselTimer = setInterval(function () {
      casentoGoBgHoverSlide(popupSlides, casentoBgHoverSlideIndex + 1, popup);
    }, 2000);
  }
}

function casentoShowBgLightbox(card) {
  const config = casentoGetBgCardLightboxConfig(card);
  if (!config) return;
  casentoShowImageLightbox(card, config, { sourceBgCard: card });
}

function casentoEnsureImageHoverHint(target) {
  if (!target) return null;
  const existing = target.querySelector('.casento-image-hover-hint');
  if (existing) return existing;
  target.classList.add('casento-image-hover-target');
  const hint = document.createElement('button');
  hint.type = 'button';
  hint.className = 'casento-image-hover-hint';
  hint.setAttribute('aria-label', 'Zvětšit náhled');
  hint.innerHTML = '<i class="ti ti-zoom-in" aria-hidden="true"></i>';
  target.appendChild(hint);
  return hint;
}

function casentoBindImageLightboxTarget(target, getConfig, options) {
  if (!target || target.dataset.imageLightboxBound) return;
  target.dataset.imageLightboxBound = '1';
  const hint = casentoEnsureImageHoverHint(target);
  if (!hint) return;

  hint.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const config = typeof getConfig === 'function' ? getConfig() : getConfig;
    if (!config || !config.images || !config.images.length) return;
    casentoShowImageLightbox(target, config, options || {});
  });
}

function casentoBindImageHoverTarget(target, getConfig) {
  casentoBindImageLightboxTarget(target, getConfig, {});
}

function casentoBindCaseTypeHoverPreviews(root) {
  if (!root) return;
  root.querySelectorAll('.chip--case-type .chip-case__media').forEach(function (media) {
    const chip = media.closest('.chip--case-type');
    if (!chip) return;
    casentoBindImageLightboxTarget(
      media,
      function () {
        const img = media.querySelector('.chip-case__img');
        const titleEl = chip.querySelector('.chip-case__title');
        let label = 'Kryt';
        if (titleEl) {
          label = titleEl.textContent.trim().split(' — ')[0] || label;
        }
        return {
          title: label,
          square: true,
          objectFit: 'contain',
          images: img && img.src ? [{ src: img.src, alt: img.alt || label }] : []
        };
      },
      { sourceCaseChip: chip, selectLabel: 'Vybrat' }
    );
  });
}

window.casentoBindImageHoverTarget = casentoBindImageHoverTarget;
window.casentoBindImageLightboxTarget = casentoBindImageLightboxTarget;

function casentoHideBgHoverPreview() {
  casentoStopBgHoverCarousel();
  if (!casentoBgHoverPreviewEl) return;
  casentoResetLightboxViewport(casentoBgHoverPreviewEl);
  casentoBgHoverPreviewEl.hidden = true;
  casentoBgHoverPreviewEl.classList.remove(
    'is-active',
    'is-bg-selectable',
    'cop-bg-hover-preview--landscape',
    'cop-bg-hover-preview--portrait',
    'cop-bg-hover-preview--square'
  );
  casentoBgHoverPreviewEl._sourceBgCard = null;
  casentoBgHoverPreviewEl._sourceCaseChip = null;
  casentoBgHoverPreviewEl._sourceSelectTarget = null;
  casentoBgHoverPreviewEl.removeAttribute('aria-label');
  const selectBtn = casentoBgHoverPreviewEl.querySelector('[data-bg-lightbox-select]');
  if (selectBtn) selectBtn.hidden = true;
  document.body.classList.remove('casento-lightbox-open');
}

function casentoBindBgHoverPreview(scope) {
  if (!scope) return;

  scope.querySelectorAll('[data-photo-background]').forEach(function (card) {
    if (card.dataset.bgLightboxBound) return;
    card.dataset.bgLightboxBound = '1';
    const target = card.querySelector('.cop-bg-thumb__carousel') || card;
    casentoBindImageLightboxTarget(
      target,
      function () {
        return casentoGetBgCardLightboxConfig(card);
      },
      { sourceBgCard: card, selectLabel: 'Vybrat pozadí' }
    );
  });
}

function casentoSetPhotoDetail(modal, mode) {
  const detailWrap = modal.querySelector('[data-photo-detail-wrap]');
  const bgWrap = modal.querySelector('[data-photo-backgrounds-wrap]');
  const grafikWrap = modal.querySelector('[data-photo-grafik-wrap]');
  const confirmBtn = modal.querySelector('[data-photo-services-confirm]');

  if (!mode) {
    if (detailWrap) detailWrap.hidden = true;
    if (bgWrap) bgWrap.hidden = true;
    if (grafikWrap) grafikWrap.hidden = true;
    casentoStopBgCarousels(modal);
    if (confirmBtn) confirmBtn.hidden = true;
    return;
  }

  if (detailWrap) detailWrap.hidden = false;

  if (mode === 'backgrounds') {
    if (bgWrap) bgWrap.hidden = false;
    if (grafikWrap) grafikWrap.hidden = true;
    initBgCarousels(modal);
    casentoStartBgCarousels(modal);
    if (confirmBtn) confirmBtn.hidden = !modal._selectedBg;
    return;
  }

  if (mode === 'grafik') {
    if (bgWrap) bgWrap.hidden = true;
    if (grafikWrap) grafikWrap.hidden = false;
    casentoStopBgCarousels(modal);
    if (confirmBtn) confirmBtn.hidden = false;
  }
}

function casentoOpenPhotoServicesModal(root, lineKey) {
  const modal = root.querySelector('[data-photo-services-modal]');
  if (!modal) {
    casentoGoToCart();
    return;
  }

  modal.hidden = false;
  document.body.classList.add('cop-services-modal-open');
  modal._lineKey = lineKey;
  modal._selectedService = null;
  modal._selectedBg = null;

  modal.querySelectorAll('[data-photo-service]').forEach(function (el) {
    el.classList.remove('is-selected');
    el.setAttribute('aria-checked', 'false');
  });
  modal.querySelectorAll('[data-photo-background]').forEach(function (el) {
    el.classList.remove('is-selected');
  });

  casentoSetPhotoDetail(modal, null);
}

function casentoClosePhotoServicesModal(root) {
  const modal = root && root.querySelector('[data-photo-services-modal]');
  if (!modal) return;
  casentoStopBgCarousels(modal);
  modal.hidden = true;
  document.body.classList.remove('cop-services-modal-open');
}

function casentoFinishPhotoService(root, serviceId, serviceLabel, backgroundLabel) {
  const modal = root.querySelector('[data-photo-services-modal]');
  const lineKey = modal && modal._lineKey;
  const props = casentoPhotoServiceProps(root, serviceId, serviceLabel, backgroundLabel);
  casentoUpdateCartPriceDisplay(root, serviceId);

  const done = function () {
    casentoClosePhotoServicesModal(root);
    casentoGoToCart();
  };

  if (!lineKey) {
    done();
    return;
  }

  casentoReplaceCartLine(root, lineKey, serviceId, props)
    .then(function () {
      return casentoRemoveCartSurcharges(root);
    })
    .then(function () {
      if (typeof window.casentoEnsureCartShipping === 'function') {
        return window.casentoEnsureCartShipping(root);
      }
      return false;
    })
    .then(done)
    .catch(function () {
      done();
    });
}

function casentoAssetUrl(root, filename) {
  const base = root.getAttribute('data-asset-base') || '/assets/';
  if (!filename) return '';
  if (filename.indexOf('http') === 0 || filename.indexOf('//') === 0) return filename;

  const qIdx = base.indexOf('?');
  if (qIdx !== -1) {
    return base.slice(0, qIdx) + filename + base.slice(qIdx);
  }
  return base + filename;
}

function casentoCreateBackgroundCard(bg, index) {
  const card = document.createElement('div');
  card.className = 'cop-bg-thumb';
  card.setAttribute('data-photo-background', '');
  card.setAttribute('data-bg-id', bg.id || 'bg-' + index);
  card.setAttribute('data-bg-label', bg.title || 'Pozadí');
  card.setAttribute('data-slide-count', '2');
  card.setAttribute('tabindex', '0');
  card.setAttribute('role', 'button');

  const bgSrc = bg.backgroundUrl || '';
  const previewSrc = bg.previewUrl || '';
  const bgAlt = bg.title || 'Pozadí';
  const previewAlt = (bg.title || 'Pozadí') + ' — náhled';

  card.innerHTML =
    '<div class="cop-bg-thumb__carousel" data-bg-carousel>' +
    '<div class="cop-bg-thumb__viewport">' +
    '<img class="cop-bg-thumb__slide is-active" src="' +
    bgSrc +
    '" alt="' +
    bgAlt.replace(/"/g, '&quot;') +
    '" width="300" height="400" loading="lazy" decoding="async" data-bg-slide>' +
    '<img class="cop-bg-thumb__slide" src="' +
    previewSrc +
    '" alt="' +
    previewAlt.replace(/"/g, '&quot;') +
    '" width="300" height="400" loading="lazy" decoding="async" data-bg-slide hidden>' +
    '</div>' +
    '<button type="button" class="cop-bg-thumb__nav cop-bg-thumb__nav--prev" data-bg-prev aria-label="Předchozí fotka">' +
    '<i class="ti ti-chevron-left" aria-hidden="true"></i></button>' +
    '<button type="button" class="cop-bg-thumb__nav cop-bg-thumb__nav--next" data-bg-next aria-label="Další fotka">' +
    '<i class="ti ti-chevron-right" aria-hidden="true"></i></button>' +
    '</div>' +
    '<div class="cop-bg-thumb__dots" data-bg-dots aria-hidden="true">' +
    '<span class="cop-bg-thumb__dot is-active" data-bg-dot></span>' +
    '<span class="cop-bg-thumb__dot" data-bg-dot></span>' +
    '</div>' +
    '<span class="cop-bg-thumb__label">' +
    (bg.title || 'Pozadí') +
    '</span>';

  return card;
}

function casentoPopulateBackgroundGrid(root, modal, backgrounds) {
  const grid = modal.querySelector('[data-photo-backgrounds-grid]');
  if (!grid || !backgrounds.length) return false;

  grid.innerHTML = '';
  backgrounds.forEach(function (bg, i) {
    grid.appendChild(
      casentoCreateBackgroundCard(
        {
          id: bg.id,
          title: bg.title,
          backgroundUrl: bg._resolvedBg,
          previewUrl: bg._resolvedPreview
        },
        i + 1
      )
    );
  });
  return true;
}

function casentoLoadBackgroundCards(root, modal) {
  const grid = modal.querySelector('[data-photo-backgrounds-grid]');
  if (!grid) return Promise.resolve(false);

  const jsonUrl = root.getAttribute('data-backgrounds-url');
  if (!jsonUrl) return Promise.resolve(false);

  const fetchUrl =
    CASENTO_ASSET_VERSION && jsonUrl.indexOf('?v=') === -1
      ? jsonUrl + '?v=' + encodeURIComponent(CASENTO_ASSET_VERSION)
      : jsonUrl;

  return fetch(fetchUrl, { credentials: 'same-origin' })
    .then(function (res) {
      if (!res.ok) return null;
      return res.json();
    })
    .then(function (data) {
      const backgrounds = (data && data.backgrounds) || [];
      const ready = backgrounds.filter(function (bg) {
        const bgSrc = casentoAssetUrl(root, bg.backgroundAsset) || bg.backgroundUrl || '';
        const previewSrc = casentoAssetUrl(root, bg.previewAsset) || bg.previewUrl || '';
        bg._resolvedBg = bgSrc;
        bg._resolvedPreview = previewSrc;
        return bgSrc && previewSrc;
      });
      if (!ready.length) return false;
      const populated = casentoPopulateBackgroundGrid(root, modal, ready);
      initBgCarousels(modal);
      const wrap = modal.querySelector('[data-photo-backgrounds-wrap]');
      if (wrap && !wrap.hidden) {
        casentoStartBgCarousels(modal);
      }
      return populated;
    })
    .catch(function () {
      return false;
    });
}

function selectPhotoBackground(modal, bgCard) {
  modal.querySelectorAll('[data-photo-background]').forEach(function (el) {
    el.classList.remove('is-selected');
  });
  bgCard.classList.add('is-selected');
  modal._selectedBg = bgCard.getAttribute('data-bg-label') || '';
  modal._selectedService = 'premium_bg';
  const premiumCard = modal.querySelector('[data-photo-service="premium_bg"]');
  if (premiumCard) {
    modal.querySelectorAll('[data-photo-service]').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    premiumCard.classList.add('is-selected');
    modal._selectedServiceLabel =
      premiumCard.getAttribute('data-photo-service-label') || 'Prémiové designové pozadí';
  }
  const confirmBtn = modal.querySelector('[data-photo-services-confirm]');
  if (confirmBtn) confirmBtn.hidden = false;
}

function casentoSelectBackgroundCard(root, bgCard) {
  if (!root || !bgCard) return false;

  const inline = root.querySelector('[data-inline-photo-services]');
  const modal = root.querySelector('[data-photo-services-modal]');

  if (inline && inline.contains(bgCard)) {
    const cards = Array.prototype.slice.call(inline.querySelectorAll('[data-photo-service]'));
    cards.forEach(function (el) {
      el.classList.remove('is-selected');
      el.setAttribute('aria-checked', 'false');
    });
    const premiumCard = inline.querySelector('[data-photo-service="premium_bg"]');
    if (premiumCard) {
      premiumCard.classList.add('is-selected');
      premiumCard.setAttribute('aria-checked', 'true');
      root.dataset.selectedPhotoService = 'premium_bg';
      root.dataset.selectedPhotoServiceLabel =
        (premiumCard.getAttribute('data-photo-service-label') || 'Prémiové designové pozadí').trim();
      casentoUpdateCartPriceDisplay(root, 'premium_bg');
    }

    inline.querySelectorAll('[data-photo-background]').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    bgCard.classList.add('is-selected');
    root.dataset.selectedPhotoBackground = bgCard.getAttribute('data-bg-label') || '';
    root.dataset.confirmedPhotoService = '';
    casentoUpdateServiceAddButtons(root);
    updateOnePageFlow(root);
    updatePickerCta(root);
    return true;
  }

  if (modal && modal.contains(bgCard)) {
    selectPhotoBackground(modal, bgCard);
    return true;
  }

  return false;
}

function initPhotoServicesModal(root) {
  const modal = root.querySelector('[data-photo-services-modal]');
  if (!modal || modal.dataset.bound) return;

  casentoLoadBackgroundCards(root, modal).finally(function () {
    if (modal.dataset.bound) return;
    modal.dataset.bound = '1';
    casentoBindPhotoServicesModal(root, modal);
  });
}

function casentoBindPhotoServicesModal(root, modal) {
  function selectPremiumCard(card) {
    modal.querySelectorAll('[data-photo-service]').forEach(function (el) {
      el.classList.remove('is-selected');
      el.setAttribute('aria-checked', 'false');
    });
    card.classList.add('is-selected');
    card.setAttribute('aria-checked', 'true');
    modal._selectedService = 'premium_bg';
    modal._selectedServiceLabel = card.getAttribute('data-photo-service-label') || 'Prémiové designové pozadí';
    modal._selectedBg = null;
    modal.querySelectorAll('[data-photo-background]').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    casentoSetPhotoDetail(modal, 'backgrounds');
    const confirmBtn = modal.querySelector('[data-photo-services-confirm]');
    if (confirmBtn) confirmBtn.hidden = true;
  }

  function selectProEditCard(card) {
    modal.querySelectorAll('[data-photo-service]').forEach(function (el) {
      el.classList.remove('is-selected');
      el.setAttribute('aria-checked', 'false');
    });
    card.classList.add('is-selected');
    card.setAttribute('aria-checked', 'true');
    modal._selectedService = 'pro_edit';
    modal._selectedServiceLabel = card.getAttribute('data-photo-service-label') || 'Profesionální úprava grafikem';
    modal._selectedBg = null;
    modal.querySelectorAll('[data-photo-background]').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    casentoSetPhotoDetail(modal, 'grafik');
  }

  modal.querySelectorAll('[data-photo-service]').forEach(function (card) {
    const serviceId = card.getAttribute('data-photo-service');
    const label = card.getAttribute('data-photo-service-label') || '';

    if (serviceId === 'premium_bg') {
      card.addEventListener('click', function () {
        selectPremiumCard(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectPremiumCard(card);
        }
      });
      return;
    }

    if (serviceId === 'pro_edit') {
      card.addEventListener('click', function () {
        selectProEditCard(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectProEditCard(card);
        }
      });
      return;
    }

    card.addEventListener('click', function () {
      casentoFinishPhotoService(root, serviceId, label, null);
    });
  });

  modal.querySelectorAll('[data-photo-background]').forEach(function (bgCard) {
    if (bgCard.dataset.boundSelect) return;
    bgCard.dataset.boundSelect = '1';
    bgCard.addEventListener('click', function (e) {
      if (e.target.closest('[data-bg-prev], [data-bg-next], [data-bg-dot]')) return;
      selectPhotoBackground(modal, bgCard);
    });
    bgCard.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (e.target.closest('[data-bg-prev], [data-bg-next], [data-bg-dot]')) return;
        e.preventDefault();
        selectPhotoBackground(modal, bgCard);
      }
    });
  });

  initBgCarousels(modal);

  const confirmBtn = modal.querySelector('[data-photo-services-confirm]');
  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      if (modal._selectedService === 'premium_bg') {
        if (!modal._selectedBg) return;
        const premiumCard = modal.querySelector('[data-photo-service="premium_bg"]');
        const label =
          (premiumCard && premiumCard.getAttribute('data-photo-service-label')) ||
          'Prémiové designové pozadí';
        casentoFinishPhotoService(root, 'premium_bg', label, modal._selectedBg);
        return;
      }
      if (modal._selectedService === 'pro_edit') {
        const proCard = modal.querySelector('[data-photo-service="pro_edit"]');
        const label =
          (proCard && proCard.getAttribute('data-photo-service-label')) ||
          'Profesionální úprava grafikem';
        casentoFinishPhotoService(root, 'pro_edit', label, null);
      }
    });
  }

  const skipBtn = modal.querySelector('[data-photo-services-skip]');
  if (skipBtn) {
    skipBtn.addEventListener('click', function () {
      const original = modal.querySelector('[data-photo-service="original"]');
      const label =
        (original && original.getAttribute('data-photo-service-label')) || 'Originální fotografie';
      casentoFinishPhotoService(root, 'original', label, null);
    });
  }

  modal.querySelectorAll('[data-photo-services-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const original = modal.querySelector('[data-photo-service="original"]');
      const label =
        (original && original.getAttribute('data-photo-service-label')) || 'Originální fotografie';
      casentoFinishPhotoService(root, 'original', label, null);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) {
      const original = modal.querySelector('[data-photo-service="original"]');
      const label =
        (original && original.getAttribute('data-photo-service-label')) || 'Originální fotografie';
      casentoFinishPhotoService(root, 'original', label, null);
    }
  });
}

function casentoGetSelectedInlineService(root) {
  const serviceId = (root.dataset.selectedPhotoService || 'original').trim();
  const serviceLabel = (root.dataset.selectedPhotoServiceLabel || 'Originální fotografie').trim();
  const background = (root.dataset.selectedPhotoBackground || '').trim();
  return { serviceId: serviceId || 'original', serviceLabel: serviceLabel || 'Originální fotografie', background: background };
}

function casentoCloseServiceConflictAlert(inline) {
  const modal = inline && inline.querySelector('[data-service-conflict-alert]');
  if (!modal) return;
  modal.hidden = true;
  document.body.classList.remove('cop-service-alert-open');
}

function casentoBindServiceConflictAlert(inline) {
  const modal = inline && inline.querySelector('[data-service-conflict-alert]');
  if (!modal || modal.dataset.boundConflict === '1') return;
  modal.dataset.boundConflict = '1';

  modal.querySelectorAll('[data-service-conflict-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      casentoCloseServiceConflictAlert(inline);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) {
      casentoCloseServiceConflictAlert(inline);
    }
  });
}

function casentoShowInlineServiceWarning(inline) {
  if (!inline) return;
  casentoBindServiceConflictAlert(inline);
  const modal = inline.querySelector('[data-service-conflict-alert]');
  if (!modal) return;
  modal.hidden = false;
  document.body.classList.add('cop-service-alert-open');
  const ok = modal.querySelector('.cop-service-alert__ok');
  if (ok) {
    window.setTimeout(function () {
      ok.focus();
    }, 0);
  }
}

function casentoAutoConfirmOriginalIfSelected(root) {
  if (root.dataset.onePage !== 'true') return;
  const selected = (root.dataset.selectedPhotoService || 'original').trim();
  if (selected !== 'original') return;
  if (!casentoHasPhoto(root)) return;
  root.dataset.confirmedPhotoService = 'original';
  casentoUpdateServiceAddButtons(root);
  updateOnePageFlow(root);
  updatePickerCta(root);
}

function casentoHasValidInlineServiceSelection(root) {
  if (root.dataset.onePage !== 'true') return true;
  const confirmed = (root.dataset.confirmedPhotoService || '').trim();
  if (!confirmed) return false;
  const selected = casentoGetSelectedInlineService(root);
  if (confirmed !== selected.serviceId) return false;
  if (confirmed === 'premium_bg') return !!selected.background;
  if (confirmed === 'original' || confirmed === 'pro_edit') return casentoHasPhoto(root);
  return true;
}

function casentoFlashServiceAddWarning(optionEl, message) {
  if (!optionEl) return;
  const warning = optionEl.querySelector('[data-service-add-warning]');
  if (!warning) return;
  warning.textContent = message;
  warning.hidden = false;
  clearTimeout(warning._hideTimer);
  warning._hideTimer = setTimeout(function () {
    warning.hidden = true;
  }, 5000);
}

function casentoSelectInlineServiceCard(inline, cards, serviceId) {
  cards.forEach(function (el) {
    const match = (el.getAttribute('data-photo-service') || '') === serviceId;
    el.classList.toggle('is-selected', match);
    el.setAttribute('aria-checked', match ? 'true' : 'false');
  });
}

function casentoUpdateServiceAddButtons(root) {
  const inline = root.querySelector('[data-inline-photo-services]');
  if (!inline) return;
  const confirmed = (root.dataset.confirmedPhotoService || '').trim();
  inline.querySelectorAll('[data-service-add]').forEach(function (btn) {
    const id = (btn.getAttribute('data-service-add') || '').trim();
    const isConfirmed = confirmed === id;
    btn.classList.toggle('is-confirmed', isConfirmed);
    if (isConfirmed) {
      btn.textContent = 'Vybráno ✓';
    } else {
      btn.textContent = btn.getAttribute('data-default-label') || 'Přidat';
    }
  });
}

function casentoTryConfirmInlineService(root, serviceId) {
  const inline = root.querySelector('[data-inline-photo-services]');
  if (!inline) return false;

  const cards = Array.prototype.slice.call(inline.querySelectorAll('[data-photo-service]'));
  const optionEl = inline.querySelector('[data-service-option="' + serviceId + '"]');
  const currentService = (root.dataset.selectedPhotoService || 'original').trim();

  if (
    serviceId !== currentService &&
    ((currentService === 'premium_bg' && serviceId === 'pro_edit') ||
      (currentService === 'pro_edit' && serviceId === 'premium_bg'))
  ) {
    casentoShowInlineServiceWarning(inline);
    return false;
  }

  if (serviceId === 'original') {
    if (!casentoHasPhoto(root)) {
      casentoFlashServiceAddWarning(optionEl, 'Nejdřív nahraj fotku v kroku 2.');
      scrollToCopStep(root, 'photo');
      return false;
    }
  }

  if (serviceId === 'premium_bg') {
    const selectedBg = inline.querySelector('[data-photo-background].is-selected');
    if (!selectedBg) {
      casentoFlashServiceAddWarning(optionEl, 'Musíš vybrat pozadí.');
      return false;
    }
    root.dataset.selectedPhotoBackground = selectedBg.getAttribute('data-bg-label') || '';
  }

  if (serviceId === 'pro_edit') {
    if (!casentoHasPhoto(root)) {
      casentoFlashServiceAddWarning(optionEl, 'Nejdřív nahraj fotku v kroku 2.');
      scrollToCopStep(root, 'photo');
      return false;
    }
  }

  const card = inline.querySelector('[data-photo-service="' + serviceId + '"]');
  casentoSelectInlineServiceCard(inline, cards, serviceId);
  root.dataset.selectedPhotoService = serviceId;
  root.dataset.selectedPhotoServiceLabel =
    (card && card.getAttribute('data-photo-service-label')) ||
    (serviceId === 'premium_bg'
      ? 'Prémiové designové pozadí'
      : serviceId === 'pro_edit'
        ? 'Profesionální úprava grafikem'
        : 'Originální fotografie');

  if (serviceId !== 'premium_bg') {
    root.dataset.selectedPhotoBackground = '';
    inline.querySelectorAll('[data-photo-background]').forEach(function (el) {
      el.classList.remove('is-selected');
    });
  }

  root.dataset.confirmedPhotoService = serviceId;
  casentoUpdateCartPriceDisplay(root, serviceId);
  casentoUpdateServiceAddButtons(root);
  updateOnePageFlow(root);
  updatePickerCta(root);
  scrollToCopStep(root, 'cart');
  return true;
}

function casentoSyncServiceOriginalPreview(root) {
  const wrap = root.querySelector('[data-photo-original-wrap]');
  const img = root.querySelector('[data-service-original-preview]');
  const empty = root.querySelector('[data-service-original-empty]');
  if (!img) return;

  const dataUrl = casentoGetStoredPhoto();
  if (dataUrl) {
    img.src = dataUrl;
    img.hidden = false;
    if (empty) empty.hidden = true;
    if (wrap) wrap.classList.add('has-photo');
  } else {
    img.removeAttribute('src');
    img.hidden = true;
    if (empty) empty.hidden = false;
    if (wrap) wrap.classList.remove('has-photo');
  }
}

function casentoShowInlineServiceDetail(root, serviceId) {
  const inline = root.querySelector('[data-inline-photo-services]');
  if (!inline) return;

  initBgCarousels(inline);
  casentoStartBgCarousels(inline);
}

function initInlinePhotoServices(root) {
  if (root.dataset.onePage !== 'true') return;
  const inline = root.querySelector('[data-inline-photo-services]');
  if (!inline || inline.dataset.boundInline) return;
  inline.dataset.boundInline = '1';

  const cards = Array.prototype.slice.call(inline.querySelectorAll('[data-photo-service]'));
  if (!cards.length) return;

  root.dataset.selectedPhotoService = 'original';
  root.dataset.selectedPhotoServiceLabel =
    (cards[0].getAttribute('data-photo-service-label') || 'Originální fotografie').trim();
  root.dataset.selectedPhotoBackground = '';
  root.dataset.confirmedPhotoService = '';
  casentoSyncServiceOriginalPreview(root);
  casentoShowInlineServiceDetail(root, 'original');
  casentoAutoConfirmOriginalIfSelected(root);

  initBgCarousels(inline);

  casentoLoadBackgroundCards(root, inline).then(function () {
    initBgCarousels(inline);
    casentoStartBgCarousels(inline);

    const bgCards = inline.querySelectorAll('[data-photo-background]');
    bgCards.forEach(function (bgCard) {
      bgCard.addEventListener('click', function (e) {
        if (e.target.closest('[data-bg-prev], [data-bg-next], [data-bg-dot]')) return;
        casentoSelectBackgroundCard(root, bgCard);
      });
    });
  });

  inline.querySelectorAll('[data-service-add]').forEach(function (btn) {
    btn.setAttribute('data-default-label', btn.textContent.trim() || 'Přidat');
    btn.addEventListener('click', function () {
      const serviceId = (btn.getAttribute('data-service-add') || 'original').trim();
      casentoTryConfirmInlineService(root, serviceId);
    });
  });

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      const nextService = (card.getAttribute('data-photo-service') || 'original').trim();
      const currentService = (root.dataset.selectedPhotoService || 'original').trim();
      if (
        ((currentService === 'premium_bg' && nextService === 'pro_edit') ||
          (currentService === 'pro_edit' && nextService === 'premium_bg')) &&
        currentService !== nextService
      ) {
        casentoShowInlineServiceWarning(inline);
        return;
      }

      cards.forEach(function (el) {
        el.classList.remove('is-selected');
        el.setAttribute('aria-checked', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-checked', 'true');

      root.dataset.selectedPhotoService = nextService;
      root.dataset.selectedPhotoServiceLabel =
        (card.getAttribute('data-photo-service-label') || 'Originální fotografie').trim();
      root.dataset.confirmedPhotoService = '';

      if (nextService === 'original') {
        casentoAutoConfirmOriginalIfSelected(root);
      }

      if (nextService !== 'premium_bg') {
        root.dataset.selectedPhotoBackground = '';
        inline.querySelectorAll('[data-photo-background]').forEach(function (el) {
          el.classList.remove('is-selected');
        });
      }

      casentoShowInlineServiceDetail(root, nextService);
      casentoUpdateCartPriceDisplay(root, nextService);
      casentoUpdateServiceAddButtons(root);
      updateOnePageFlow(root);
      updatePickerCta(root);
    });
  });

  casentoUpdateServiceAddButtons(root);
}

function casentoAddSecondCaseToCart(root, cta) {
  const phone = (root.dataset.selectedPhone || '').trim();
  const url = root.getAttribute('data-cart-add-url') || '/cart/add.js';
  const hasCloud = root.getAttribute('data-cloudinary-cloud') && root.getAttribute('data-cloudinary-preset');
  const selectedService = casentoGetSelectedInlineService(root);

  if (!isPhoneSelectionComplete(root)) return;
  if (!casentoGetStoredPhoto()) {
    alert('Nejdřív nahraj fotku v horní části stránky.');
    return;
  }
  if (!casentoHasValidInlineServiceSelection(root)) {
    alert('Nejdřív potvrď foto službu tlačítkem Přidat u vybrané varianty.');
    scrollToCopStep(root, 'service');
    return;
  }

  cta.disabled = true;
  const prevText = cta.textContent;
  cta.textContent = 'Připravuji…';

  casentoResolveBundleVariant(root)
    .then(function (variantId) {
      if (!variantId) throw new Error('missing_bundle_product');

      cta.textContent = hasCloud ? 'Nahrávám fotku…' : 'Přidávám…';

      return casentoUploadPhotoToCloud(root).then(function (photoUrl) {
        if (!photoUrl && hasCloud) {
          throw new Error(
            'Fotku se nepodařilo nahrát. Zkontroluj Cloudinary v nastavení motivu (cloud name + upload preset).'
          );
        }
        if (!photoUrl && !hasCloud) {
          const go = confirm(
            'Fotku se nepodařilo uložit pro výrobu — v objednávce bude jen model telefonu.\n\n' +
              'Pokračovat bez fotky v objednávce?'
          );
          if (!go) throw new Error('cancelled');
        }

        cta.textContent = 'Přidávám…';
        const props = casentoBuildCaseLineProperties(root, phone, selectedService, photoUrl, hasCloud);
        props['_Konfigurováno'] = 'ano';
        props['_Položka'] = 'druhy-kryt';

        return casentoRemoveBundleCartLines(root).then(function () {
          return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1, properties: props }]
            })
          }).then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          });
        });
      });
    })
    .then(function () {
      casentoFinishSecondCaseModeUrl();
      cta.disabled = false;
      cta.textContent = prevText;
      updatePickerCta(root);
      casentoGoToCart();
    })
    .catch(function (err) {
      if (err && err.message === 'cancelled') {
        cta.disabled = false;
        cta.textContent = prevText;
        return;
      }
      if (err && err.message === 'missing_bundle_product') {
        alert(
          'Produkt „druhy-kryt-akce“ v obchodě chybí.\n\n' +
            'V Shopify Admin vytvoř produkt s handle „druhy-kryt-akce“ (595 Kč).'
        );
        cta.disabled = false;
        cta.textContent = prevText;
        return;
      }
      const msg =
        (err && err.description) || (err && err.message) || 'Nepodařilo se přidat druhý kryt do košíku.';
      alert(msg);
      cta.disabled = false;
      cta.textContent = prevText;
      updatePickerCta(root);
    });
}

function casentoAddToCart(root, cta) {
  if (casentoIsSecondCaseMode(root)) {
    casentoAddSecondCaseToCart(root, cta);
    return;
  }

  const phone = (root.dataset.selectedPhone || '').trim();
  const url = root.getAttribute('data-cart-add-url') || '/cart/add.js';
  const hasCloud = root.getAttribute('data-cloudinary-cloud') && root.getAttribute('data-cloudinary-preset');
  const selectedService = casentoGetSelectedInlineService(root);

  if (!isPhoneSelectionComplete(root)) return;
  if (!casentoGetStoredPhoto()) {
    alert('Nejdřív nahraj fotku v horní části stránky.');
    return;
  }
  if (!casentoHasValidInlineServiceSelection(root)) {
    alert('Nejdřív potvrď foto službu tlačítkem Přidat u vybrané varianty.');
    scrollToCopStep(root, 'service');
    return;
  }

  cta.disabled = true;
  const prevText = cta.textContent;
  cta.textContent = 'Připravuji…';

  casentoResolvePickerVariant(root, selectedService.serviceId)
    .then(function (variantId) {
      if (!variantId) {
        throw new Error('missing_product');
      }

      cta.textContent = hasCloud ? 'Nahrávám fotku…' : 'Přidávám…';

      return casentoUploadPhotoToCloud(root).then(function (photoUrl) {
        if (!photoUrl && hasCloud) {
          throw new Error(
            'Fotku se nepodařilo nahrát. Zkontroluj Cloudinary v nastavení motivu (cloud name + upload preset).'
          );
        }
        if (!photoUrl && !hasCloud) {
          const go = confirm(
            'Fotku se nepodařilo uložit pro výrobu — v objednávce bude jen model telefonu.\n\n' +
              'Pokračovat bez fotky v objednávce?'
          );
          if (!go) {
            throw new Error('cancelled');
          }
        }

        cta.textContent = 'Přidávám…';
        const props = casentoBuildCaseLineProperties(root, phone, selectedService, photoUrl, hasCloud);

        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1, properties: props }]
          })
        }).then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        });
      });
    })
    .then(function (addResult) {
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: addResult, data: { source: 'casento-custom-case' } }
        })
      );
      cta.disabled = false;
      cta.textContent = prevText;
      updatePickerCta(root);

      if (root.dataset.onePage !== 'true') {
        casentoGoToCart();
        return;
      }

      const shippingPromise =
        typeof window.casentoEnsureCartShipping === 'function'
          ? window.casentoEnsureCartShipping(root)
          : Promise.resolve(false);

      return shippingPromise
        .then(function () {
          return casentoRemoveCartSurcharges(root);
        })
        .then(function () {
          casentoGoToCart();
        });
    })
    .catch(function (err) {
      if (err && err.message === 'cancelled') {
        cta.disabled = false;
        cta.textContent = prevText;
        return;
      }
      if (err && (err.message === 'missing_product' || err.message === 'product_not_found')) {
        alert(
          'Produkt „vlastni-kryt-casento“ v obchodě chybí.\n\n' +
            'V Shopify Admin → Produkty → Import nahraj soubor:\n' +
            'import/vlastni-kryt-casento.csv\n\n' +
            'Nebo v editoru motivu vyber produkt v poli „Produkt (vlastní kryt)“.'
        );
        cta.disabled = false;
        cta.textContent = prevText;
        updatePickerCta(root);
        return;
      }
      const msg =
        (err && err.description) || (err && err.message) || 'Nepodařilo se přidat do košíku.';
      alert(msg);
      cta.disabled = false;
      cta.textContent = prevText;
      updatePickerCta(root);
    });
}

function resolveVariant(series, variant) {
  if (variant && typeof variant === 'object') {
    return {
      label: variant.label || variant.full || series,
      full: variant.full || series
    };
  }
  if (!variant) {
    return { label: 'Základní', full: series };
  }
  return { label: variant, full: series + ' ' + variant };
}

function resolveSeriesDisplay(entry) {
  if (entry.seriesKey) return entry.seriesKey;
  return entry.series;
}

const CASENTO_MODEL_ORDER = {
  "samsung": [
    "Samsung Galaxy S26 Ultra",
    "Samsung Galaxy S26+",
    "Samsung Galaxy S26",
    "Samsung Galaxy A17 5G",
    "Samsung Galaxy Z Flip7 5G",
    "Samsung Galaxy S25 FE 5G",
    "Samsung Galaxy S25 Edge 5G",
    "Samsung Galaxy A56 5G A566B",
    "Samsung Galaxy A36 5G",
    "Samsung Galaxy A26 5G A266B",
    "Samsung Galaxy Z Flip6 5G",
    "Samsung Galaxy A16 5G",
    "Samsung Galaxy A15 A156B 5G",
    "Samsung Galaxy A15 A155F 4G",
    "Samsung Galaxy S25 Ultra",
    "Samsung Galaxy S25+",
    "Samsung Galaxy A55 5G A556B",
    "Samsung Galaxy A35 5G A356B",
    "Samsung Galaxy A25 A256B 5G",
    "Samsung Galaxy A05s A057G",
    "Samsung Galaxy Z Flip5 5G",
    "Samsung Galaxy A54 5G A546B A54",
    "Samsung Galaxy A34 5G A346B",
    "Samsung Galaxy A14",
    "Samsung Galaxy A14 5G A146P",
    "Samsung Galaxy S23 Ultra 5G",
    "Samsung Galaxy S23+ 5G",
    "Samsung Galaxy A73 5G",
    "Samsung Galaxy A23 A236B 5G",
    "Samsung Galaxy S22 Ultra 5G",
    "Samsung Galaxy S22+ 5G",
    "Samsung Galaxy S22 5G",
    "Samsung Galaxy A53 5G A536 A53",
    "Samsung Galaxy A33 5G A336",
    "Samsung Galaxy S21 FE 5G",
    "Samsung Galaxy A22 A226B 5G",
    "Samsung Galaxy A13 5G",
    "Samsung Galaxy A13 4G A135",
    "Samsung Galaxy A52 5G A525F",
    "Samsung Galaxy A32 5G A326B",
    "Samsung Galaxy A12 A125F",
    "Samsung Galaxy Note 20 Ultra",
    "Samsung Galaxy A42",
    "Samsung Galaxy S20 FE",
    "Samsung Galaxy A72 A725F",
    "Samsung Galaxy A71 A715G",
    "Samsung Galaxy A51",
    "Samsung Galaxy Note 10 N970F",
    "Samsung Galaxy S20+ G985F",
    "Samsung Galaxy Note 9 N960F",
    "Samsung Galaxy S9 G960F",
    "Samsung Galaxy S8 G950F"
  ],
  "xiaomi": [
    "Xiaomi 17 Ultra",
    "Xiaomi 17",
    "Xiaomi Redmi Note 15 Pro+",
    "Xiaomi Redmi Note 15 Pro 5G",
    "Xiaomi Redmi 15C 4G",
    "Xiaomi 15",
    "Xiaomi Poco F7 Pro 5G",
    "Xiaomi Poco X7 Pro 5G",
    "Xiaomi Redmi Note 14 Pro 4G",
    "Xiaomi Redmi Note 14 5G",
    "Xiaomi Redmi Note 14 4G",
    "Xiaomi Redmi 14C",
    "Xiaomi 14 Ultra",
    "Xiaomi 14",
    "Xiaomi Redmi Note 13 Pro+ 5G",
    "Xiaomi Redmi Note 13 Pro 5G",
    "Xiaomi Redmi Note 13 Pro 4G",
    "Xiaomi Redmi Note 13 5G",
    "Xiaomi Redmi Note 13",
    "Xiaomi Redmi 13C 4G",
    "Xiaomi Poco F6",
    "Xiaomi 13T Pro",
    "Xiaomi 13T",
    "Xiaomi 13 Pro",
    "XiaoMi 13(5G)",
    "Xiaomi Poco F5 Pro 5G",
    "Xiaomi Redmi Note 12 Pro+ 5G",
    "Xiaomi Redmi Note 12 Pro 5G",
    "Xiaomi 12T",
    "Xiaomi Redmi Note 11 Pro 5G",
    "Xiaomi 12 Pro",
    "XiaoMi 12",
    "Xiaomi 12X",
    "Xiaomi 11T",
    "Xiaomi 11 Lite 5G",
    "Xiaomi Redmi Note 10 Pro",
    "Xiaomi Redmi Note 10S",
    "Xiaomi Poco F3",
    "Xiaomi Mi 11 Lite",
    "Xiaomi Poco F2 Pro",
    "XiaoMi15 Ultra",
    "XiaoMi14 Pro"
  ],
  "honor": [
    "Honor 400 Pro 5G",
    "Honor 400 5G",
    "Honor Magic7 Pro 5G",
    "Honor 200 Pro",
    "Honor 200",
    "Honor Magic6 Pro",
    "Honor Magic5 Pro",
    "Honor 90 5G",
    "Honor 70"
  ],
  "huawei": [
    "Huawei Nova 9 SE",
    "Huawei Nova 9",
    "Huawei P50",
    "Huawei Mate 40 Pro",
    "Huawei P40 Pro",
    "Huawei P40",
    "Huawei P30 Lite",
    "Huawei P30",
    "Huawei P20 Pro",
    "Huawei P20 Lite"
  ],
  "vivo": [
    "Vivo X200 Pro",
    "Vivo X60 Pro 5G"
  ],
  "google": [
    "Google Pixel 10",
    "Google Pixel 10 Pro",
    "Google Pixel 9a",
    "Google Pixel 9 Pro",
    "Google Pixel 9",
    "Google Pixel 8a",
    "Google Pixel 8 Pro",
    "Google Pixel 8",
    "Google Pixel 10 ProXL"
  ],
  "oneplus": [
    "OnePlus 13R 5G",
    "OnePlus 12 5G",
    "OnePlus 9"
  ],
  "oppo": [
    "OPPO Find X9",
    "OPPO Reno 7 5G",
    "OPPO Reno 5 5G"
  ],
  "apple": [
    "Apple iPhone 17e",
    "Apple iPhone 17 Pro Max",
    "Apple iPhone 17 Pro",
    "Apple iPhone 17 Air",
    "Apple iPhone 17",
    "Apple iPhone 16e",
    "Apple iPhone 16 Pro Max",
    "Apple iPhone 16 Pro",
    "Apple iPhone 16 Plus",
    "Apple iPhone 16",
    "Apple iPhone 15 Pro Max",
    "Apple iPhone 15 Pro",
    "Apple iPhone 15 Plus",
    "Apple iPhone 15",
    "Apple iPhone 14 Plus",
    "Apple iPhone 14 Pro Max",
    "Apple iPhone 14 Pro",
    "Apple iPhone 14",
    "Apple iPhone SE 2022",
    "Apple iPhone 13 Pro Max",
    "Apple iPhone 13 Pro",
    "Apple iPhone 13",
    "Apple iPhone 13 mini",
    "Apple iPhone 12 Pro Max",
    "Apple iPhone 12 mini",
    "Apple iPhone 12 Pro",
    "Apple iPhone 12",
    "Apple iPhone SE 2020",
    "Apple iPhone 11 Pro Max",
    "Apple iPhone 11 Pro",
    "Apple iPhone 11",
    "Apple iPhone XR",
    "Apple iphone XS max",
    "Apple iPhone X/XS",
    "Apple iPhone 8 Plus",
    "Apple iPhone 8",
    "Apple iPhone 7 Plus",
    "Apple iPhone 7"
  ]
};

let casentoModelOrderMaps = null;

function casentoNormalizeModelName(name) {
  return String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\(\)\[\]\/\-_,.]/g, ' ')
    .replace(/\+/g, ' plus ')
    .replace(/\((20\d{2})\)/g, ' $1 ')
    .replace(/\biphone\s+se\b/g, 'iphone se')
    .replace(/\bpro\s*xl\b/g, 'pro xl')
    .replace(/\bxiaomi15\b/g, 'xiaomi 15')
    .replace(/\bxiaomi14\b/g, 'xiaomi 14')
    .replace(/\b(apple|samsung|xiaomi|honor|huawei|vivo|google|oneplus|oppo)\b/g, ' ')
    .replace(/\b5g\b/g, ' 5g ')
    .replace(/\s+/g, ' ')
    .trim();
}

function casentoBuildModelOrderMaps() {
  if (casentoModelOrderMaps) return casentoModelOrderMaps;
  casentoModelOrderMaps = {};
  Object.keys(CASENTO_MODEL_ORDER).forEach(function (brand) {
    const map = {};
    CASENTO_MODEL_ORDER[brand].forEach(function (model, idx) {
      map[casentoNormalizeModelName(model)] = idx;
    });
    casentoModelOrderMaps[brand] = map;
  });
  return casentoModelOrderMaps;
}

function phoneModelPdfOrderRank(brandId, name) {
  const brand = String(brandId || '').trim().toLowerCase();
  if (!brand) return Number.POSITIVE_INFINITY;
  const allMaps = casentoBuildModelOrderMaps();
  const brandMap = allMaps[brand];
  if (!brandMap) return Number.POSITIVE_INFINITY;

  const normalized = casentoNormalizeModelName(name);
  if (!normalized) return Number.POSITIVE_INFINITY;
  if (Object.prototype.hasOwnProperty.call(brandMap, normalized)) return brandMap[normalized];

  let best = Number.POSITIVE_INFINITY;
  Object.keys(brandMap).forEach(function (key) {
    if (!key) return;
    if (normalized.includes(key) || key.includes(normalized)) {
      best = Math.min(best, brandMap[key]);
    }
  });
  return best;
}

/** Skóre pro řazení modelů od nejnovějšího (vyšší = novější). */
function phoneModelNewnessScore(name) {
  const raw = String(name || '');
  const n = raw.toLowerCase();
  let score = 0;

  const iphoneSe = n.match(/iphone\s+se(?:\s+(20\d{2}))?/);
  if (iphoneSe) {
    const yr = iphoneSe[1] ? parseInt(iphoneSe[1], 10) : 2016;
    score = Math.max(score, 50000 + yr);
  } else {
    const iphone = n.match(/iphone\s+(\d{1,2})/);
    if (iphone) score = Math.max(score, 200000 + parseInt(iphone[1], 10) * 1000);
  }

  const galS = n.match(/galaxy\s+s(\d{1,2})/);
  if (galS) score = Math.max(score, 180000 + parseInt(galS[1], 10) * 1000);

  const galZ = n.match(/galaxy\s+z\s*(?:fold|flip)(\d{1,2})/);
  if (galZ) score = Math.max(score, 175000 + parseInt(galZ[1], 10) * 1000);

  const galNote = n.match(/galaxy\s+note\s*(\d{1,2})/);
  if (galNote) score = Math.max(score, 160000 + parseInt(galNote[1], 10) * 1000);

  const galA = n.match(/galaxy\s+a(\d{1,3})/);
  if (galA) score = Math.max(score, 120000 + parseInt(galA[1], 10) * 100);

  const galM = n.match(/galaxy\s+m(\d{1,2})/);
  if (galM) score = Math.max(score, 110000 + parseInt(galM[1], 10) * 100);

  const pixel = n.match(/pixel\s*(\d{1,2})/);
  if (pixel) score = Math.max(score, 150000 + parseInt(pixel[1], 10) * 1000);

  const redmiNote = n.match(/redmi\s+note\s+(\d{1,2})/);
  if (redmiNote) score = Math.max(score, 148000 + parseInt(redmiNote[1], 10) * 1000);

  const redmi = n.match(/redmi\s+(\d{1,2})/);
  if (redmi && !redmiNote) score = Math.max(score, 130000 + parseInt(redmi[1], 10) * 1000);

  const mi = n.match(/\bmi\s+(\d{1,2})\b/);
  if (mi) score = Math.max(score, 145000 + parseInt(mi[1], 10) * 1000);

  const poco = n.match(/poco\s+[a-z]*\s*(\d{1,2})/);
  if (poco) score = Math.max(score, 135000 + parseInt(poco[1], 10) * 1000);

  const oneplus = n.match(/oneplus\s+(?:ace\s*)?(\d{1,2})/);
  if (oneplus) score = Math.max(score, 145000 + parseInt(oneplus[1], 10) * 1000);

  const reno = n.match(/reno\s+(\d{1,2})/);
  if (reno) score = Math.max(score, 130000 + parseInt(reno[1], 10) * 1000);

  const findX = n.match(/find\s+x(\d{1,2})/);
  if (findX) score = Math.max(score, 140000 + parseInt(findX[1], 10) * 1000);

  const honorNum = n.match(/(?:honor|magic)\s*(\d{1,2})/);
  if (honorNum) score = Math.max(score, 130000 + parseInt(honorNum[1], 10) * 1000);

  const mate = n.match(/mate\s+(\d{1,2})/);
  if (mate) score = Math.max(score, 140000 + parseInt(mate[1], 10) * 1000);

  const pSeries = n.match(/\bp\s*(\d{1,2})\b/);
  if (pSeries) score = Math.max(score, 135000 + parseInt(pSeries[1], 10) * 1000);

  const vivoX = n.match(/\bx\s*(\d{2,3})\b/);
  if (vivoX) score = Math.max(score, 140000 + parseInt(vivoX[1], 10) * 10);

  const vivoV = n.match(/\bv\s*(\d{1,3})\b/);
  if (vivoV) score = Math.max(score, 130000 + parseInt(vivoV[1], 10) * 10);

  const yearMatch = n.match(/\b(20[12]\d)\b/g);
  if (yearMatch && score === 0) {
    yearMatch.forEach(function (y) {
      score = Math.max(score, parseInt(y, 10) * 100);
    });
  }

  if (/iphone\s*x/i.test(n) && !iphoneSe && !/iphone\s+\d/.test(n)) score = Math.max(score, 90000);

  if (score === 0) {
    const nums = n.match(/\d+/g);
    if (nums) {
      nums.forEach(function (num) {
        const v = parseInt(num, 10);
        if (v >= 5 && v <= 999) score = Math.max(score, v * 100);
      });
    }
  }

  if (/ultra|pro\s*max|pro\+|proxl/i.test(raw)) score += 90;
  else if (/\bpro\b/i.test(raw)) score += 70;
  else if (/\+|plus/i.test(raw)) score += 50;
  else if (/\bfe\b/i.test(raw)) score += 30;
  else if (/\blite\b/i.test(raw)) score += 10;

  return score;
}

function sortPhoneCatalogEntries(entries, brandId) {
  const order = CASENTO_MODEL_ORDER[brandId];
  if (!order || !order.length) return entries || [];

  const rank = {};
  order.forEach(function (name, idx) {
    rank[name] = idx;
  });

  return (entries || []).slice().sort(function (a, b) {
    const sa = resolveSeriesDisplay(a);
    const sb = resolveSeriesDisplay(b);
    const ra = Object.prototype.hasOwnProperty.call(rank, sa) ? rank[sa] : 99999;
    const rb = Object.prototype.hasOwnProperty.call(rank, sb) ? rank[sb] : 99999;
    if (ra !== rb) return ra - rb;
    return sa.localeCompare(sb, 'cs');
  });
}

function hasVariantStep(entry) {
  const v = entry && entry.variants;
  if (!v || !v.length) return false;
  if (v.length === 1 && v[0] === '') return false;
  return true;
}

function getActiveBrandId(root) {
  const brandChip = root.querySelector('[data-chip-group="brand"] .chip.on[data-brand-id]');
  return brandChip ? brandChip.getAttribute('data-brand-id') : '';
}

/** MagSafe podle sloupce v objednané kryty.pdf */
function casentoLoadPhoneCatalog(root) {
  const base = window.CasentoPhoneModels || {};
  const catalog = JSON.parse(JSON.stringify(base));
  const magsafeMap = window.CasentoPhoneMagSafe ? Object.assign({}, window.CasentoPhoneMagSafe) : {};

  const el = root.querySelector('[data-casento-phone-catalog-editor]');
  if (!el) {
    root._casentoMagSafeMap = null;
    return catalog;
  }

  try {
    const models = JSON.parse(el.textContent);
    if (!models || !models.length) {
      root._casentoMagSafeMap = null;
      return catalog;
    }

    models.forEach(function (m) {
      const brand = String(m.brand || 'apple').trim();
      const series = String(m.series || '').trim();
      if (!series) return;
      if (!catalog[brand]) catalog[brand] = [];

      const entry = { series: series, magsafe: m.magsafe === true };
      let found = false;
      for (let i = 0; i < catalog[brand].length; i++) {
        if (catalog[brand][i].series === series) {
          catalog[brand][i] = entry;
          found = true;
          break;
        }
      }
      if (!found) catalog[brand].push(entry);
      magsafeMap[series] = m.magsafe === true;
    });
    root._casentoMagSafeMap = magsafeMap;
  } catch (e) {
    root._casentoMagSafeMap = null;
  }

  Object.keys(catalog).forEach(function (brand) {
    catalog[brand] = sortPhoneCatalogEntries(catalog[brand], brand);
  });

  return catalog;
}

function phoneSupportsMagSafe(brandId, phoneName, root) {
  const phone = (phoneName || '').trim();
  if (root && root._casentoMagSafeMap && Object.prototype.hasOwnProperty.call(root._casentoMagSafeMap, phone)) {
    return root._casentoMagSafeMap[phone] === true;
  }
  const map = window.CasentoPhoneMagSafe;
  if (map && phone && Object.prototype.hasOwnProperty.call(map, phone)) {
    return map[phone] === true;
  }
  return false;
}

function isPhoneSelectionComplete(root) {
  const phone = (root.dataset.selectedPhone || '').trim();
  if (!phone) return false;
  if (!phoneSupportsMagSafe(getActiveBrandId(root), phone, root)) return true;
  return !!(root.dataset.selectedCaseType || '').trim();
}

function normalizeSearchText(value) {
  return (value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

function getModelSearchQuery(root, input) {
  const phone = (root.dataset.selectedPhone || '').trim();
  const value = (input && input.value ? input.value : '').trim();
  if (phone && normalizeSearchText(value) === normalizeSearchText(phone)) {
    return '';
  }
  return value;
}

function filterCatalogEntries(entries, query) {
  const rows = (entries || []).map(function (entry, index) {
    return { entry: entry, index: index };
  });
  const q = normalizeSearchText(query.trim());
  if (!q) return rows;
  const words = q.split(/\s+/).filter(Boolean);
  return rows.filter(function (row) {
    const name = normalizeSearchText(resolveSeriesDisplay(row.entry));
    return words.every(function (word) {
      return name.indexOf(word) !== -1;
    });
  });
}

function hideModelSearchResults(root) {
  const list = root.querySelector('[data-model-search-results]');
  const empty = root.querySelector('[data-model-search-empty]');
  const input = root.querySelector('[data-model-search-input]');
  if (list) list.hidden = true;
  if (empty) empty.hidden = true;
  if (input) input.setAttribute('aria-expanded', 'false');
}

function usesBrandModelList(root) {
  return !!(root.querySelector('[data-model-list]') && root.dataset.onePage === 'true');
}

function getModelResultsContainer(root) {
  if (usesBrandModelList(root)) {
    return root.querySelector('[data-model-list]');
  }
  return root.querySelector('[data-model-search-results]');
}

function getBrandGridColumns(wrap) {
  if (!wrap) return 3;
  const cols = window.getComputedStyle(wrap).gridTemplateColumns.split(' ').filter(Boolean).length;
  return cols || 3;
}

function positionBrandPanel(root, brandChip) {
  const wrap = root.querySelector('[data-brand-wrap]');
  const panel = root.querySelector('[data-brand-panel]');
  if (!wrap || !panel || !brandChip) return;
  const tiles = Array.prototype.slice.call(wrap.querySelectorAll('[data-brand-id]'));
  const index = tiles.indexOf(brandChip);
  if (index < 0) return;
  const cols = getBrandGridColumns(wrap);
  const rowEnd = Math.min(Math.floor(index / cols) * cols + cols - 1, tiles.length - 1);
  tiles[rowEnd].after(panel);
  panel.hidden = false;
}

function updateBrandSearchPlaceholder(root, brandChip) {
  const input = root.querySelector('[data-model-search-input]');
  if (!input || !brandChip) return;
  const template =
    input.getAttribute('data-search-placeholder-template') || 'Vyhledat model telefonu pro {brand}…';
  const label = brandChip.getAttribute('data-brand-label') || 'telefon';
  input.placeholder = template.replace(/\{brand\}/g, label);
}

function showModelSearchField(root) {
  const input = root.querySelector('[data-model-search-input]');
  if (input) input.value = '';
  hideModelSearchResults(root);
}

function showModelSearchSelected(root, phoneName) {
  const input = root.querySelector('[data-model-search-input]');
  if (input) input.value = phoneName;
  hideModelSearchResults(root);
}

function renderModelSearchResults(root, brandId) {
  const list = getModelResultsContainer(root);
  const dropdown = root.querySelector('[data-model-search-results]');
  const empty = root.querySelector('[data-model-search-empty]');
  const input = root.querySelector('[data-model-search-input]');
  const entries = root._casentoBrandEntries || [];
  const brandListMode = usesBrandModelList(root);
  if (!list || !input) return;
  if (!brandId) {
    list.innerHTML = '';
    if (empty) empty.hidden = true;
    hideModelSearchResults(root);
    return;
  }

  const filtered = filterCatalogEntries(entries, getModelSearchQuery(root, input));
  const selectedPhone = (root.dataset.selectedPhone || '').trim();
  list.innerHTML = '';

  if (!entries.length) {
    if (!brandListMode) hideModelSearchResults(root);
    if (empty) {
      empty.hidden = false;
      empty.textContent = 'Modely pro tuto značku brzy doplníme.';
    }
    return;
  }

  if (!filtered.length) {
    if (brandListMode) {
      if (empty) {
        empty.hidden = false;
        empty.textContent = 'Žádný model nenalezen.';
      }
    } else {
      if (dropdown) dropdown.hidden = true;
      if (empty) {
        empty.hidden = false;
        empty.textContent = 'Žádný model nenalezen.';
      }
      input.setAttribute('aria-expanded', 'false');
    }
    return;
  }

  if (empty) empty.hidden = true;
  if (brandListMode) {
    input.setAttribute('aria-expanded', 'true');
  } else if (dropdown) {
    dropdown.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  filtered.forEach(function (row) {
    const label = resolveSeriesDisplay(row.entry);
    if (brandListMode) {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'picker-model-list__item';
      item.setAttribute('role', 'option');
      if (selectedPhone && normalizeSearchText(label) === normalizeSearchText(selectedPhone)) {
        item.classList.add('is-selected');
      }
      item.textContent = label;
      item.addEventListener('click', function () {
        selectCatalogEntry(root, brandId, row.index);
      });
      list.appendChild(item);
      return;
    }

    const item = document.createElement('li');
    item.className = 'picker-model-search__item';
    item.setAttribute('role', 'option');
    item.textContent = label;
    item.addEventListener('mousedown', function (e) {
      e.preventDefault();
    });
    item.addEventListener('click', function () {
      selectCatalogEntry(root, brandId, row.index);
    });
    list.appendChild(item);
  });
}

function selectCatalogEntry(root, brandId, seriesIndex) {
  showModelSearchSelected(root, resolveSeriesDisplay((root._casentoBrandEntries || [])[seriesIndex]));
  if (!usesBrandModelList(root)) {
    hideModelSearchResults(root);
  } else {
    renderModelSearchResults(root, brandId);
  }
  onSeriesChange(root, brandId, seriesIndex);
}

function ensureModelSearchBindings(root) {
  if (root.dataset.modelSearchBound === 'true') return;
  const input = root.querySelector('[data-model-search-input]');
  if (!input) return;
  root.dataset.modelSearchBound = 'true';

  input.addEventListener('input', function () {
    const phone = (root.dataset.selectedPhone || '').trim();
    if (phone && normalizeSearchText(input.value) !== normalizeSearchText(phone)) {
      root.dataset.selectedPhone = '';
      root.dataset.selectedCaseType = '';
      collapseVariantStep(root);
      collapseCaseTypeStep(root);
      updateCasePreview(root);
      updatePickerCta(root);
      updateOnePageFlow(root);
    }
    renderModelSearchResults(root, getActiveBrandId(root));
  });
  input.addEventListener('focus', function () {
    if (!usesBrandModelList(root)) {
      renderModelSearchResults(root, getActiveBrandId(root));
    }
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      hideModelSearchResults(root);
      input.blur();
    }
  });

  document.addEventListener('click', function (e) {
    const search = root.querySelector('[data-model-search]');
    if (search && !search.contains(e.target)) {
      hideModelSearchResults(root);
    }
  });
}

function hideBrandPanel(root) {
  const panel = root.querySelector('[data-brand-panel]');
  if (panel) panel.hidden = true;
  const list = root.querySelector('[data-model-list]');
  if (list) list.innerHTML = '';
  hideModelSearchResults(root);
}

function clearBrandSelection(root) {
  const brandGroup = root.querySelector('[data-chip-group="brand"]');
  if (brandGroup) {
    brandGroup.querySelectorAll('.chip').forEach(function (c) {
      c.classList.remove('on');
    });
  }
  hideBrandPanel(root);
  root._casentoBrandEntries = [];
  root.dataset.selectedPhone = '';
  root.dataset.selectedCaseType = '';
  const input = root.querySelector('[data-model-search-input]');
  if (input) input.value = '';
  collapseVariantStep(root);
  collapseCaseTypeStep(root);
  updateCasePreview(root);
  updatePickerCta(root);
  updateOnePageFlow(root);
}

function initPhonePicker(root) {
  const brandGroup = root.querySelector('[data-chip-group="brand"]');
  const modelSearch = root.querySelector('[data-model-search]');
  const variantGroup = root.querySelector('[data-chip-group="variant"]');
  if (!brandGroup || !modelSearch || !variantGroup) return;
  if (root.dataset.pickerReady === 'true') return;
  root.dataset.pickerReady = 'true';

  root._casentoPhoneCatalog = casentoLoadPhoneCatalog(root);
  ensureModelSearchBindings(root);

  brandGroup.querySelectorAll('.chip[data-brand-id]').forEach(function (brandChip) {
    brandChip.addEventListener('click', function () {
      const wasOn = brandChip.classList.contains('on');
      brandGroup.querySelectorAll('.chip').forEach(function (c) {
        c.classList.remove('on');
      });
      if (wasOn) {
        clearBrandSelection(root);
        updateCaseShape(root, '', '');
        return;
      }
      brandChip.classList.add('on');
      onBrandChange(root, brandChip.getAttribute('data-brand-id'), brandChip);
    });
  });

  hideBrandPanel(root);
  updateCaseShape(root, '', '');

  if (root.querySelector('[data-brand-panel]')) {
    let resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        const current = brandGroup.querySelector('.chip.on[data-brand-id]');
        if (current) positionBrandPanel(root, current);
      }, 120);
    });
  }
}

function onBrandChange(root, brandId, brandChip) {
  collapseVariantStep(root);
  collapseCaseTypeStep(root);
  root.dataset.selectedPhone = '';
  root.dataset.selectedCaseType = '';
  renderSeriesForBrand(root, brandId);
  if (brandChip) {
    positionBrandPanel(root, brandChip);
    updateBrandSearchPlaceholder(root, brandChip);
  }
  renderModelSearchResults(root, brandId);
  updateCasePreview(root);
  updatePickerCta(root);
  updateOnePageFlow(root);
}

function renderSeriesForBrand(root, brandId) {
  const catalog = root._casentoPhoneCatalog || {};
  root._casentoBrandEntries = catalog[brandId] || [];
  showModelSearchField(root);
  const input = root.querySelector('[data-model-search-input]');
  if (input) input.value = '';
  if (!usesBrandModelList(root)) {
    hideModelSearchResults(root);
  }
  const empty = root.querySelector('[data-model-search-empty]');
  if (empty) empty.hidden = true;
}

function onPhoneSelected(root) {
  const brandId = getActiveBrandId(root);
  const phone = (root.dataset.selectedPhone || '').trim();
  if (phone) showModelSearchSelected(root, phone);

  if (phoneSupportsMagSafe(brandId, phone, root)) {
    root.dataset.selectedCaseType = '';
    expandCaseTypeStep(root);
    renderCaseTypeOptions(root);
    updateCasePreview(root);
    updatePickerCta(root);
    updateOnePageFlow(root);
    return;
  }

  collapseCaseTypeStep(root);
  root.dataset.selectedCaseType = '';
  finishPhoneSelection(root);
}

function finishPhoneSelection(root) {
  updateCasePreview(root);
  updatePickerCta(root);
  updateOnePageFlow(root);
  if (root.dataset.onePage === 'true' && isPhoneSelectionComplete(root)) {
    scrollToCopStep(root, 'photo');
  }
}

function onSeriesChange(root, brandId, seriesIndex) {
  const catalog = root._casentoPhoneCatalog || {};
  const entry = (catalog[brandId] || [])[seriesIndex];
  if (!entry) return;

  collapseCaseTypeStep(root);
  root.dataset.selectedCaseType = '';

  if (!hasVariantStep(entry)) {
    collapseVariantStep(root);
    root.dataset.selectedPhone = entry.series;
    onPhoneSelected(root);
    return;
  }

  if (entry.variants.length === 1) {
    const meta = resolveVariant(entry.series, entry.variants[0]);
    collapseVariantStep(root);
    root.dataset.selectedPhone = meta.full;
    onPhoneSelected(root);
    return;
  }

  expandVariantStep(root);
  renderVariants(root, entry);
  updateCasePreview(root);
  updatePickerCta(root);
  updateOnePageFlow(root);
}

function renderVariants(root, entry) {
  const variantGroup = root.querySelector('[data-chip-group="variant"]');
  variantGroup.innerHTML = '';
  root.dataset.selectedPhone = '';
  root.dataset.selectedCaseType = '';
  collapseCaseTypeStep(root);

  entry.variants.forEach(function (variant) {
    const meta = resolveVariant(entry.series, variant);
    const chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'chip';
    chip.textContent = meta.label;
    chip.dataset.fullName = meta.full;
    chip.addEventListener('click', function () {
      variantGroup.querySelectorAll('.chip').forEach(function (c) {
        c.classList.remove('on');
      });
      chip.classList.add('on');
      root.dataset.selectedPhone = chip.dataset.fullName;
      onPhoneSelected(root);
    });
    variantGroup.appendChild(chip);
  });
  updateCasePreview(root);
}

function collapseVariantStep(root) {
  const variantRow = root.querySelector('[data-picker-step="variant"]');
  const variantGroup = root.querySelector('[data-chip-group="variant"]');
  if (variantRow) variantRow.classList.add('picker-row--collapsed');
  if (variantGroup) variantGroup.innerHTML = '';
}

function expandVariantStep(root) {
  const variantRow = root.querySelector('[data-picker-step="variant"]');
  if (variantRow) variantRow.classList.remove('picker-row--collapsed');
}

function collapseCaseTypeStep(root) {
  const caseTypeRow = root.querySelector('[data-picker-step="caseType"]');
  const caseTypeGroup = root.querySelector('[data-chip-group="caseType"]');
  if (caseTypeRow) caseTypeRow.classList.add('picker-row--collapsed');
  if (caseTypeGroup) caseTypeGroup.innerHTML = '';
}

function expandCaseTypeStep(root) {
  const caseTypeRow = root.querySelector('[data-picker-step="caseType"]');
  if (caseTypeRow) caseTypeRow.classList.remove('picker-row--collapsed');
}

function renderCaseTypeOptions(root) {
  const caseTypeGroup = root.querySelector('[data-chip-group="caseType"]');
  if (!caseTypeGroup) return;
  caseTypeGroup.innerHTML = '';

  const pricing = casentoGetPricing(root);
  const standardImage = root.getAttribute('data-case-standard-image') || '';
  const magsafeImage = root.getAttribute('data-case-magsafe-image') || '';
  [
    {
      value: 'Standardní',
      label: 'Standardní',
      price: casentoFormatCz(pricing.base),
      image: standardImage,
      desc:
        'Dvoudílný Double Case: měkké TPU jádro + pevný plast. Výborná ochrana při pádech a čistý povrch pro kvalitní potisk.'
    },
    {
      value: 'MagSafe',
      label: 'MagSafe',
      price: casentoFormatCz(pricing.base + pricing.magsafe),
      image: magsafeImage,
      desc:
        'Stejná dvoudílná ochrana jako Double Case, navíc integrované magnety MagSafe pro nabíječky, držáky, peněženky i powerbanky.'
    }
  ].forEach(function (opt) {
    const chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'chip chip--case-type';
    chip.innerHTML =
      '<span class="chip-case__media">' +
      (opt.image
        ? '<img class="chip-case__img" src="' + opt.image + '" alt="' + opt.label + '" loading="lazy" decoding="async">'
        : '') +
      '</span>' +
      '<span class="chip-case__body">' +
      '<strong class="chip-case__title">' +
      opt.label +
      ' — ' +
      opt.price +
      '</strong>' +
      '<span class="chip-case__desc">' +
      opt.desc +
      '</span>' +
      '</span>';
    chip.dataset.caseType = opt.value;
    chip.addEventListener('click', function () {
      caseTypeGroup.querySelectorAll('.chip--case-type').forEach(function (c) {
        c.classList.remove('on');
      });
      chip.classList.add('on');
      root.dataset.selectedCaseType = opt.value;
      casentoUpdateCartPriceDisplay(root, 'original');
      finishPhoneSelection(root);
    });
    caseTypeGroup.appendChild(chip);
  });

  casentoBindCaseTypeHoverPreviews(root);
}

function updatePickerCta(root) {
  const cta = root.querySelector('[data-picker-cta]');
  const hint = root.querySelector('[data-picker-cta-hint]');
  if (!cta) return;

  const cartLabel = casentoIsSecondCaseMode(root)
    ? root.getAttribute('data-second-case-cta') || 'Přidat druhý kryt do košíku'
    : cta.getAttribute('data-cta-cart') || 'Přidat do košíku';
  const phone = (root.dataset.selectedPhone || '').trim();
  const hasPhoto = casentoHasPhoto(root);
  const isOnePage = root.dataset.onePage === 'true';

  if (isOnePage) {
    cta.textContent = cartLabel;
    cta.dataset.mode = 'cart';
    cta.disabled = !(isPhoneSelectionComplete(root) && hasPhoto && casentoHasValidInlineServiceSelection(root));
    if (hint) hint.hidden = true;
    if (isPhoneSelectionComplete(root)) {
      const selected = casentoGetSelectedInlineService(root);
      casentoUpdateCartPriceDisplay(root, selected.serviceId || 'original');
    } else if (casentoIsSecondCaseMode(root)) {
      casentoUpdateCartPriceDisplay(root, 'original');
    }
    updateOnePageFlow(root);
    return;
  }

  const initial = cta.getAttribute('data-cta-initial') || 'Nejdřív vyber telefon';
  const uploadPrefix = cta.getAttribute('data-cta-upload-prefix') || 'Nahrát fotku pro ';
  const uploadSuffix = cta.getAttribute('data-cta-upload-suffix') || ' →';
  const pickPhoneHint = cta.getAttribute('data-cta-pick-phone') || '';

  if (!isPhoneSelectionComplete(root)) {
    cta.dataset.mode = 'idle';
    cta.textContent = initial;
    cta.disabled = true;
    if (hint) {
      hint.hidden = !hasPhoto;
      hint.textContent = hasPhoto ? pickPhoneHint : '';
    }
    return;
  }

  cta.disabled = false;
  if (hint) hint.hidden = true;

  if (hasPhoto) {
    cta.dataset.mode = 'cart';
    cta.textContent = cartLabel;
  } else {
    cta.dataset.mode = 'upload';
    cta.textContent = uploadPrefix + phone + uploadSuffix;
  }
}

(function () {
  const header = document.querySelector('.casento-header');
  if (!header) return;

  const btn = header.querySelector('[data-nav-toggle]');
  const drawer = header.querySelector('.nav-drawer');
  if (!btn || !drawer) return;

  function setOpen(open) {
    drawer.classList.toggle('is-open', open);
    document.body.classList.toggle('casento-nav-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.innerHTML = open
      ? '<i class="ti ti-x" aria-hidden="true"></i>'
      : '<i class="ti ti-menu-2" aria-hidden="true"></i>';
  }

  btn.addEventListener('click', function () {
    setOpen(!drawer.classList.contains('is-open'));
  });

  drawer.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      setOpen(false);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      setOpen(false);
    }
  });
})();
